/* eslint-disable */
/* prettier-ignore */
// @ts-nocheck 
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  ObjMap: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AddCouponCustomersInput = {
  cnpjs: Array<Scalars['String']['input']>;
};

export type AddCouponCustomersOut = {
  __typename?: 'AddCouponCustomersOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<AddCouponCustomersOutCustomer>>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<AddCouponCustomersOutProduct>>>;
  sales_channel?: Maybe<Array<Maybe<AddCouponCustomersOutSalesChannel>>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type AddCouponCustomersOutCustomer = {
  __typename?: 'AddCouponCustomersOutCustomer';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cnpj: Scalars['String']['output'];
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type AddCouponCustomersOutProduct = {
  __typename?: 'AddCouponCustomersOutProduct';
  sku: Scalars['String']['output'];
};

export type AddCouponCustomersOutSalesChannel = {
  __typename?: 'AddCouponCustomersOutSalesChannel';
  name: Scalars['String']['output'];
};

export type AddCouponInRoute_Input = {
  name: Scalars['String']['input'];
};

export type AddCouponOut = {
  __typename?: 'AddCouponOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddCouponCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddCouponCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddCouponCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddCouponOut400 = {
  __typename?: 'AddCouponOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddCouponOut403 = {
  __typename?: 'AddCouponOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddCouponOut404 = {
  __typename?: 'AddCouponOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddCouponOut409 = {
  __typename?: 'AddCouponOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddCouponProductsInput = {
  products: Array<Scalars['String']['input']>;
};

export type AddCouponProductsOut = {
  __typename?: 'AddCouponProductsOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<AddCouponProductsOutCustomer>>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<AddCouponProductsOutProduct>>>;
  sales_channel?: Maybe<Array<Maybe<AddCouponProductsOutSalesChannel>>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type AddCouponProductsOutCustomer = {
  __typename?: 'AddCouponProductsOutCustomer';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cnpj: Scalars['String']['output'];
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type AddCouponProductsOutProduct = {
  __typename?: 'AddCouponProductsOutProduct';
  sku: Scalars['String']['output'];
};

export type AddCouponProductsOutSalesChannel = {
  __typename?: 'AddCouponProductsOutSalesChannel';
  name: Scalars['String']['output'];
};

export type AddCustomCartProductsInRoute_Input = {
  assembled_kit?: InputMaybe<Scalars['JSON']['input']>;
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  items: Array<InputMaybe<CustomCartItem_Input>>;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomCartProductsOut = {
  __typename?: 'AddCustomCartProductsOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddProductsCustomCart_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddProductsCustomCart_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddProductsCustomCart_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddProductsCustomCart_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddDiscountInRoute_Input = {
  value: Scalars['Int']['input'];
};

export type AddDiscountOut = {
  __typename?: 'AddDiscountOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddDiscountCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddDiscountCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddDiscountCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddDiscountCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddDiscountOut400 = {
  __typename?: 'AddDiscountOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddDiscountOut403 = {
  __typename?: 'AddDiscountOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddDiscountOut404 = {
  __typename?: 'AddDiscountOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddDiscountOut409 = {
  __typename?: 'AddDiscountOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddFinancialTransferInRoute_Input = {
  type: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type AddFinancialTransferOut = {
  __typename?: 'AddFinancialTransferOut';
  financial_transfer?: Maybe<FinancialTransfer>;
  id: Scalars['String']['output'];
};

export type AddInsuranceInRoute_Input = {
  insurance_coverage_years?: InputMaybe<Scalars['Int']['input']>;
};

export type AddInsuranceOut = {
  __typename?: 'AddInsuranceOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddInsuranceCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddInsuranceCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddInsuranceCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddInsuranceCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddInsuranceOut400 = {
  __typename?: 'AddInsuranceOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddInsuranceOut403 = {
  __typename?: 'AddInsuranceOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddInsuranceOut404 = {
  __typename?: 'AddInsuranceOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddInsuranceOut409 = {
  __typename?: 'AddInsuranceOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AddManualDiscountInRoute_Input = {
  value: Scalars['Float']['input'];
};

export type AddManualDiscountOut = {
  __typename?: 'AddManualDiscountOut';
  id: Scalars['String']['output'];
};

export type AddProductCustomCartInRoute_Input = {
  item: ItemIn_Input;
};

export type AddProductCustomCartOut = {
  __typename?: 'AddProductCustomCartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddProductCustomCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddProductCustomCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddProductCustomCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddProductCustomCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddProductCustomCartOut400 = {
  __typename?: 'AddProductCustomCartOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductCustomCartOut403 = {
  __typename?: 'AddProductCustomCartOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductCustomCartOut404 = {
  __typename?: 'AddProductCustomCartOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductCustomCartOut409 = {
  __typename?: 'AddProductCustomCartOut409';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductCustomCartOut_Input2 = {
  __typename?: 'AddProductCustomCartOut_Input2';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddProductInRoute_Input = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  item: CartItemIn_Input;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type AddProductOut = {
  __typename?: 'AddProductOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddProductCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddProductCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddProductCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddProductCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AddProductOut400 = {
  __typename?: 'AddProductOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductOut403 = {
  __typename?: 'AddProductOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductOut404 = {
  __typename?: 'AddProductOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductOut409 = {
  __typename?: 'AddProductOut409';
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductOut_Input2 = {
  __typename?: 'AddProductOut_Input2';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AddProductCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AddProductCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AddProductCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AddProductCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type AddressIn = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  district: Scalars['String']['input'];
  ibgecode: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressOut = {
  __typename?: 'AddressOut';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  district: Scalars['String']['output'];
  ibgecode?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AdjustCartInRoute_Input = {
  notes?: InputMaybe<Scalars['JSON']['input']>;
  proposal?: InputMaybe<Scalars['JSON']['input']>;
  shipping?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
};

export type AdjustCartOut = {
  __typename?: 'AdjustCartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AdjustCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  internal_order_id?: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AdjustCart_OneOf_0_Payment>;
  payment_expiration_date?: Maybe<Scalars['String']['output']>;
  payment_link?: Maybe<Scalars['String']['output']>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AdjustCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AdjustCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdjustCartOut400 = {
  __typename?: 'AdjustCartOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustCartOut403 = {
  __typename?: 'AdjustCartOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustCartOut404 = {
  __typename?: 'AdjustCartOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustCartOut409 = {
  __typename?: 'AdjustCartOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustItemInRoute_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
};

export type AdjustItemOut = {
  __typename?: 'AdjustItemOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AdjustItemCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AdjustItemCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AdjustItemCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AdjustItemCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdjustItemOut400 = {
  __typename?: 'AdjustItemOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustItemOut403 = {
  __typename?: 'AdjustItemOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustItemOut404 = {
  __typename?: 'AdjustItemOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustItemOut409 = {
  __typename?: 'AdjustItemOut409';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdjustItemOut_Input2 = {
  __typename?: 'AdjustItemOut_Input2';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_AdjustItemCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_AdjustItemCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_AdjustItemCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_AdjustItemCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdjustKitRequest = {
  __typename?: 'AdjustKitRequest';
  channel: Scalars['String']['output'];
  dc_id: Scalars['Int']['output'];
  inverter_manufacturer?: Maybe<Scalars['String']['output']>;
  inverter_nominal_power?: Maybe<Scalars['String']['output']>;
  inverter_type?: Maybe<Scalars['String']['output']>;
  network_type?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  region: Scalars['String']['output'];
  segmentation_id?: Maybe<Scalars['String']['output']>;
  structure_installation?: Maybe<Scalars['String']['output']>;
};

export type AdjustSpareProductItemIn = {
  amount: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type AssembleKitOut = {
  __typename?: 'AssembleKitOut';
  cart_id: Scalars['UUID']['output'];
  dc_id: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type AssembleKitV2ItemInput = {
  amount: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type AssembleKitV2Out = {
  __typename?: 'AssembleKitV2Out';
  cart_id: Scalars['UUID']['output'];
  dc_id: Scalars['Int']['output'];
  region: Scalars['String']['output'];
};

export type AuditChecksInfo = {
  __typename?: 'AuditChecksInfo';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  has_cost?: Maybe<Scalars['Boolean']['output']>;
  has_price_for_region?: Maybe<Scalars['Boolean']['output']>;
  has_product_info?: Maybe<Scalars['Boolean']['output']>;
};

export type AuditItemOut = {
  __typename?: 'AuditItemOut';
  amount: Scalars['Int']['output'];
  checks?: Maybe<AuditChecksInfo>;
  product?: Maybe<AuditProductInfo>;
  reasons: Array<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stock?: Maybe<AuditStockInfo>;
};

export type AuditProductInfo = {
  __typename?: 'AuditProductInfo';
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AuditStockInfo = {
  __typename?: 'AuditStockInfo';
  current?: Maybe<Scalars['Int']['output']>;
  future?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityAuditOut = {
  __typename?: 'AvailabilityAuditOut';
  cart_id: Scalars['String']['output'];
  distribution_center_id?: Maybe<Scalars['Int']['output']>;
  items: Array<AuditItemOut>;
  overall_status: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type Available_At = {
  __typename?: 'Available_At';
  DateTime?: Maybe<Scalars['DateTime']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type BigNumber = {
  __typename?: 'BigNumber';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BillingIn = {
  address: AddressIn;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type BillingOut = {
  __typename?: 'BillingOut';
  address: AddressOut;
};

export type Billing_Type = {
  __typename?: 'Billing_Type';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Branch = {
  __typename?: 'Branch';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type BuyerIn_Input = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  document_number: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state_registration?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type BuyerOut = {
  __typename?: 'BuyerOut';
  company_name?: Maybe<Scalars['String']['output']>;
  document_number: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state_registration?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Can_Deliver_To_Region = {
  __typename?: 'Can_Deliver_To_Region';
  Boolean?: Maybe<Scalars['Boolean']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type CancelOrderOut = {
  __typename?: 'CancelOrderOut';
  order_id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CartItemIn_Input = {
  amount: Scalars['Int']['input'];
  discount_rate: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  price_raw: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type CartItemOut = {
  __typename?: 'CartItemOut';
  amount: Scalars['Int']['output'];
  available_at?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  details?: Maybe<Array<Maybe<DetailsOut>>>;
  discount_inove_amount: Scalars['Float']['output'];
  discount_rate?: Maybe<Scalars['Float']['output']>;
  discount_solfacil_plus_amount: Scalars['Float']['output'];
  images: Array<Maybe<ImageOut>>;
  info?: Maybe<Array<Maybe<CustomCartItemInfo>>>;
  power?: Maybe<Scalars['Float']['output']>;
  pre_sale: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  price_from: Scalars['Float']['output'];
  price_raw: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  status: CartItemStatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  total_from: Scalars['Float']['output'];
};

export type CartItemStatusOut = {
  __typename?: 'CartItemStatusOut';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type CartOut = {
  __typename?: 'CartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Query_GetProposals_Proposals_Items_Coupon>;
  created_at: Scalars['DateTime']['output'];
  created_at_long?: Maybe<Scalars['String']['output']>;
  created_at_short?: Maybe<Scalars['String']['output']>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expiration_days?: Maybe<Scalars['String']['output']>;
  expired_at_long?: Maybe<Scalars['String']['output']>;
  expired_at_short?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_battery?: Maybe<Scalars['Boolean']['output']>;
  has_hybrid_inverter?: Maybe<Scalars['Boolean']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items?: Maybe<Array<Maybe<CartItemOut>>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Query_GetProposals_Proposals_Items_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  products?: Maybe<Array<Maybe<CartSpareProductsOut>>>;
  proposal?: Maybe<Query_GetProposals_Proposals_Items_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Query_GetProposals_Proposals_Items_Shipping>;
  should_confirm_on_add_kit?: Maybe<Scalars['Boolean']['output']>;
  status: StatusOut;
  subregion?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type CartSpareProductsOut = {
  __typename?: 'CartSpareProductsOut';
  items?: Maybe<Array<Maybe<GetSpareProductsAssortmentOut>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Cart_Id = {
  __typename?: 'Cart_Id';
  UUID?: Maybe<Scalars['UUID']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Category = {
  __typename?: 'Category';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CategoryOut = {
  __typename?: 'CategoryOut';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ChangeShippingTypeOut = {
  __typename?: 'ChangeShippingTypeOut';
  id: Scalars['String']['output'];
  shipping: ShippingOut;
};

export type City = {
  __typename?: 'City';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type CityOut = {
  __typename?: 'CityOut';
  first_cep: Scalars['String']['output'];
  ibge_code?: Maybe<Scalars['String']['output']>;
  is_capital: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ClearOut = {
  __typename?: 'ClearOut';
  success: Scalars['Boolean']['output'];
};

export type ClearOut404 = {
  __typename?: 'ClearOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type CloseOrderInRoute_Input = {
  billing?: InputMaybe<BillingIn>;
  buyer: BuyerIn_Input;
  files?: InputMaybe<Array<InputMaybe<File>>>;
  notes?: InputMaybe<Notes>;
};

export type Combo = {
  __typename?: 'Combo';
  Boolean?: Maybe<Scalars['Boolean']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Company_Name = {
  __typename?: 'Company_Name';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Complement = {
  __typename?: 'Complement';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type CompleteCustomCartOut = {
  __typename?: 'CompleteCustomCartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_CompleteCustomCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  inverters?: Maybe<Array<Maybe<Inverter>>>;
  items: Array<Maybe<CartItemOut>>;
  modules?: Maybe<Array<Maybe<Module>>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_CompleteCustomCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_CompleteCustomCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_CompleteCustomCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CompleteCustomCartOut400 = {
  __typename?: 'CompleteCustomCartOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CompleteCustomCartOut403 = {
  __typename?: 'CompleteCustomCartOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CompleteCustomCartOut404 = {
  __typename?: 'CompleteCustomCartOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CompleteCustomCartOut409 = {
  __typename?: 'CompleteCustomCartOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ConvertToProposalOut = {
  __typename?: 'ConvertToProposalOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_ConvertToProposal_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_ConvertToProposal_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_ConvertToProposal_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_ConvertToProposal_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CounterofferSummaryItem = {
  __typename?: 'CounterofferSummaryItem';
  id: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CounterofferSummaryOut = {
  __typename?: 'CounterofferSummaryOut';
  items: Array<Maybe<CounterofferSummaryItem>>;
};

export type CouponCustomerInput = {
  available_quantity: Scalars['Int']['input'];
  cnpj: Scalars['String']['input'];
};

export type CouponDetailsOut = {
  __typename?: 'CouponDetailsOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<CouponDetailsOutCustomer>>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<CouponDetailsOutProduct>>>;
  sales_channel?: Maybe<Array<Maybe<CouponDetailsOutSalesChannel>>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type CouponDetailsOutCustomer = {
  __typename?: 'CouponDetailsOutCustomer';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cnpj: Scalars['String']['output'];
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type CouponDetailsOutProduct = {
  __typename?: 'CouponDetailsOutProduct';
  sku: Scalars['String']['output'];
};

export type CouponDetailsOutSalesChannel = {
  __typename?: 'CouponDetailsOutSalesChannel';
  name: Scalars['String']['output'];
};

export type CouponOut = {
  __typename?: 'CouponOut';
  _fake?: Maybe<Scalars['String']['output']>;
};

export type CouponProductInput = {
  sku: Scalars['String']['input'];
};

export type CreateCounterofferInRoute_Input = {
  channel: Scalars['String']['input'];
  original_proposal: OriginalProposalIn;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCounterofferOut = {
  __typename?: 'CreateCounterofferOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['Date']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<CouponOut>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_coverage_years?: Maybe<Scalars['Int']['output']>;
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<PaymentOut>;
  pre_sale: Scalars['Boolean']['output'];
  proposal?: Maybe<ProposalOut>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<ShippingOut>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  summary: CounterofferSummaryOut;
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
};

export type CreateCouponInput = {
  available_quantity?: InputMaybe<Scalars['Int']['input']>;
  customers?: InputMaybe<Array<CouponCustomerInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['Float']['input']>;
  discount_rate?: InputMaybe<Scalars['Float']['input']>;
  expires_in: Scalars['String']['input'];
  min_purchase_amount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  products?: InputMaybe<Array<CouponProductInput>>;
  sales_channel?: InputMaybe<Array<SalesChannelInput>>;
};

export type CreateCouponOut = {
  __typename?: 'CreateCouponOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<CreateCouponOutCustomer>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<CreateCouponOutProduct>>;
  sales_channel?: Maybe<Array<CreateCouponOutSalesChannel>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type CreateCouponOutCustomer = {
  __typename?: 'CreateCouponOutCustomer';
  available_quantity: Scalars['Int']['output'];
  cnpj: Scalars['String']['output'];
};

export type CreateCouponOutProduct = {
  __typename?: 'CreateCouponOutProduct';
  sku: Scalars['String']['output'];
};

export type CreateCouponOutSalesChannel = {
  __typename?: 'CreateCouponOutSalesChannel';
  name: Scalars['String']['output'];
};

export type CreateCustomCartInRoute_Input = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  subregion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomCartOut = {
  __typename?: 'CreateCustomCartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_CreateCustomCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_CreateCustomCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_CreateCustomCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_CreateCustomCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateCustomCartOut400 = {
  __typename?: 'CreateCustomCartOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomCartOut403 = {
  __typename?: 'CreateCustomCartOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomCartOut404 = {
  __typename?: 'CreateCustomCartOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomCartOut409 = {
  __typename?: 'CreateCustomCartOut409';
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomCartOut_Input2 = {
  __typename?: 'CreateCustomCartOut_Input2';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_CreateCustomCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_CreateCustomCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_CreateCustomCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_CreateCustomCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateFintechSimulationInput = {
  bill_value: Scalars['Float']['input'];
  document: Scalars['String']['input'];
  down_payment: Scalars['Float']['input'];
  person_type: Scalars['String']['input'];
  project_value: Scalars['Float']['input'];
  representative_document?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderFlowOut = {
  __typename?: 'CreateOrderFlowOut';
  flow_type: OrderFlowTypeEnum;
  order_id: Scalars['UUID']['output'];
  payment?: Maybe<Mutation_CreateOrderFlow_OneOf_0_Payment>;
  status: OrderFlowStatusDto;
};

export type CreateOrderInRoute_Input = {
  cart_id: Scalars['UUID']['input'];
  category: Scalars['String']['input'];
  channel: OrderChannelDto_Input;
  comments?: InputMaybe<Scalars['JSON']['input']>;
  customer: OrderCustomerDto_Input;
  dc_id: Scalars['Int']['input'];
  items: Array<InputMaybe<OrderItemDto_Input>>;
  payment: OrderPaymentDto_Input;
  pricing: Array<InputMaybe<OrderPricingDto_Input>>;
  raw_value: Scalars['Float']['input'];
  region: Scalars['String']['input'];
  shipping: OrderShippingDto_Input;
  total_value: Scalars['Float']['input'];
  type: OrderTypeEnum;
  user: OrderUserDto_Input;
};

export type CreateOrderInvoiceItem = {
  __typename?: 'CreateOrderInvoiceItem';
  delivery_id?: Maybe<Scalars['String']['output']>;
  erp_protheus_id?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CreateOrderInvoiceOut = {
  __typename?: 'CreateOrderInvoiceOut';
  invoices: Array<CreateOrderInvoiceItem>;
};

export type CreateOrderMirrorByIdOut = {
  __typename?: 'CreateOrderMirrorByIdOut';
  expires_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateOrderOut = {
  __typename?: 'CreateOrderOut';
  cart_id?: Maybe<Cart_Id>;
  category: Scalars['String']['output'];
  channel: OrderChannelDto;
  comments?: Maybe<Mutation_CreateOrder_OneOf_0_Comments>;
  created_at: Scalars['DateTime']['output'];
  customer: OrderCustomerDto;
  dc_id: Scalars['Int']['output'];
  erp?: Maybe<Mutation_CreateOrder_OneOf_0_Erp>;
  id: Scalars['UUID']['output'];
  items: Array<Maybe<OrderItemDto>>;
  legacy_id?: Maybe<Legacy_Id>;
  order_flows?: Maybe<Array<Maybe<OrderFlowDto>>>;
  order_number: Scalars['Int']['output'];
  payment: OrderPaymentDto;
  pricing: Array<Maybe<OrderPricingDto>>;
  raw_value: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  reservation_id: Scalars['UUID']['output'];
  shipping: OrderShippingDto;
  status: OrderStatusDto;
  total_value: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  user: OrderUserDto;
};

export type CreateProposalSheetByIdOut = {
  __typename?: 'CreateProposalSheetByIdOut';
  expires_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateProposalsSheetOut = {
  __typename?: 'CreateProposalsSheetOut';
  expires_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CustomCartItemInfo = {
  __typename?: 'CustomCartItemInfo';
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomCartItem_Input = {
  amount: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type CustomKitOffer = {
  __typename?: 'CustomKitOffer';
  description: Scalars['String']['output'];
  inverter_manufacturer: Scalars['String']['output'];
  items: Array<CustomKitOfferItem>;
  module_manufacturer: Scalars['String']['output'];
  request: AdjustKitRequest;
  tag: CustomKitOfferTag;
  total_value: Scalars['String']['output'];
  value_per_wp: Scalars['String']['output'];
};

export type CustomKitOfferItem = {
  __typename?: 'CustomKitOfferItem';
  category: Scalars['String']['output'];
  details: Array<CustomKitOfferItemDetail>;
};

export type CustomKitOfferItemDetail = {
  __typename?: 'CustomKitOfferItemDetail';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomKitOfferProduct = {
  __typename?: 'CustomKitOfferProduct';
  amount: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type CustomKitOfferTag = {
  __typename?: 'CustomKitOfferTag';
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CustomKitOfferV2 = {
  __typename?: 'CustomKitOfferV2';
  description: Scalars['String']['output'];
  inverter_manufacturer: Scalars['String']['output'];
  items: Array<CustomKitOfferV2Item>;
  module_manufacturer: Scalars['String']['output'];
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  request: CustomKitOfferV2Request;
  tag?: Maybe<CustomKitOfferTag>;
  total_value: Scalars['String']['output'];
  value_per_wp: Scalars['String']['output'];
};

export type CustomKitOfferV2Item = {
  __typename?: 'CustomKitOfferV2Item';
  category: Scalars['String']['output'];
  details: Array<CustomKitOfferV2ItemDetail>;
};

export type CustomKitOfferV2ItemDetail = {
  __typename?: 'CustomKitOfferV2ItemDetail';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomKitOfferV2Request = {
  __typename?: 'CustomKitOfferV2Request';
  dc_id: Scalars['Int']['output'];
  items: Array<CustomKitOfferV2RequestItems>;
  region: Scalars['String']['output'];
};

export type CustomKitOfferV2RequestItems = {
  __typename?: 'CustomKitOfferV2RequestItems';
  amount: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type Datasheet = {
  __typename?: 'Datasheet';
  label?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeliveryForecastOut = {
  __typename?: 'DeliveryForecastOut';
  capital: DeliveryTimeOut;
  countryside: DeliveryTimeOut;
};

export type DeliveryTimeOut = {
  __typename?: 'DeliveryTimeOut';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type Detail = {
  __typename?: 'Detail';
  category?: Maybe<Scalars['String']['output']>;
  descriptions?: Maybe<Array<Maybe<DetailDescription>>>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DetailDescription = {
  __typename?: 'DetailDescription';
  amount?: Maybe<Scalars['Int']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DetailDescriptionOut = {
  __typename?: 'DetailDescriptionOut';
  amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DetailDescription_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Detail_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  descriptions?: InputMaybe<Array<InputMaybe<DetailDescription_Input>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DetailsOut = {
  __typename?: 'DetailsOut';
  category: Scalars['String']['output'];
  datasheet?: Maybe<Scalars['String']['output']>;
  descriptions: Array<Maybe<DetailDescriptionOut>>;
  id: Scalars['Int']['output'];
};

export type Dimension = {
  __typename?: 'Dimension';
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  Float?: Maybe<Scalars['Float']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type DiscountOut = {
  __typename?: 'DiscountOut';
  amount: Scalars['Float']['output'];
  result: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type DistributionCenter = {
  __typename?: 'DistributionCenter';
  active: Scalars['Boolean']['output'];
  address?: Maybe<DistributionCenterAddress>;
  created_at: Scalars['DateTime']['output'];
  erp_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Updated_At;
};

export type DistributionCenterAddress = {
  __typename?: 'DistributionCenterAddress';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip_code: Scalars['String']['output'];
};

export type DistributionCenterShipping = {
  __typename?: 'DistributionCenterShipping';
  active: Scalars['Boolean']['output'];
  can_deliver_to_region: Can_Deliver_To_Region;
  created_at: Scalars['DateTime']['output'];
  erp_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  priority: Priority;
  region: Region;
  updated_at: Updated_At;
};

export type DistributionCenterShippingList = {
  __typename?: 'DistributionCenterShippingList';
  data: Array<Maybe<DistributionCenterShipping>>;
  meta: Pagination;
};

export type DownloadOrderDocumentOut = {
  __typename?: 'DownloadOrderDocumentOut';
  expires_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type EligibleFinancing = {
  __typename?: 'EligibleFinancing';
  all_payments_sent?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  financed_value?: Maybe<Scalars['Int']['output']>;
  flow_provider?: Maybe<Scalars['String']['output']>;
  formalized_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  installed_at?: Maybe<Scalars['String']['output']>;
  is_combo?: Maybe<Scalars['Boolean']['output']>;
  is_expired?: Maybe<Scalars['Boolean']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  person_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  section_statuses?: Maybe<SectionStatuses>;
  status?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
  system_power?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type Facet = {
  __typename?: 'Facet';
  facet_name?: Maybe<Scalars['String']['output']>;
  filter_name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<FacetOption>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FacetOption = {
  __typename?: 'FacetOption';
  count?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FacetOptionOut = {
  __typename?: 'FacetOptionOut';
  count: Scalars['Int']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FacetOut = {
  __typename?: 'FacetOut';
  filter_name: Scalars['String']['output'];
  options: Array<Maybe<FacetOptionOut>>;
  title: Scalars['String']['output'];
};

export type File = {
  file: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type FillPaymentCartV2RouteMethodOut = {
  id: Scalars['Int']['input'];
  installments?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type FillPaymentInRoute_Input = {
  billing?: InputMaybe<BillingIn>;
  buyer: BuyerIn_Input;
  files?: InputMaybe<Array<InputMaybe<File>>>;
  financing?: InputMaybe<FinancingIn>;
  fintech_id?: InputMaybe<Scalars['Int']['input']>;
  method: MethodIn_Input;
  notes?: InputMaybe<Notes>;
  triangular_transaction?: InputMaybe<TriangularTransactionIn>;
};

export type FillPaymentOut400 = {
  __typename?: 'FillPaymentOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillPaymentOut403 = {
  __typename?: 'FillPaymentOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillPaymentOut404 = {
  __typename?: 'FillPaymentOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillPaymentOut_Input = {
  __typename?: 'FillPaymentOut_Input';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_FillPaymentCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_FillPaymentCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_FillPaymentCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_FillPaymentCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FillPaymentOut_Output = {
  __typename?: 'FillPaymentOut_Output';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_FillPaymentCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_FillPaymentCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_FillPaymentCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_FillPaymentCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FillPaymentV2InRoute_Input = {
  financing?: InputMaybe<FinancingIn>;
  method: FillPaymentCartV2RouteMethodOut;
};

export type FillShippingInRoute_Input = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  delivery_rural_area?: InputMaybe<Scalars['Boolean']['input']>;
  forecast?: InputMaybe<Scalars['JSON']['input']>;
  recipient?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
};

export type FillShippingOut = {
  __typename?: 'FillShippingOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_FillShippingCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_FillShippingCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_FillShippingCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_FillShippingCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FillShippingOut400 = {
  __typename?: 'FillShippingOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillShippingOut403 = {
  __typename?: 'FillShippingOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillShippingOut404 = {
  __typename?: 'FillShippingOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type FillShippingOut_Input2 = {
  __typename?: 'FillShippingOut_Input2';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_FillShippingCart_OneOf_1_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_FillShippingCart_OneOf_1_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_FillShippingCart_OneOf_1_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_FillShippingCart_OneOf_1_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FillShippingV2InRoute_Input = {
  address?: InputMaybe<AddressIn>;
  delivery_rural_area?: InputMaybe<Scalars['Boolean']['input']>;
  recipient?: InputMaybe<RecipientIn>;
  type: Scalars['String']['input'];
};

export type FillTriangularTransactionAddress = {
  __typename?: 'FillTriangularTransactionAddress';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  district: Scalars['String']['output'];
  ibgecode: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type FillTriangularTransactionAlert = {
  __typename?: 'FillTriangularTransactionAlert';
  description: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FillTriangularTransactionInRoute_Input = {
  file: File;
};

export type FillTriangularTransactionOut = {
  __typename?: 'FillTriangularTransactionOut';
  alert?: Maybe<FillTriangularTransactionAlert>;
  alerts: Array<FillTriangularTransactionAlert>;
  invoiceChecks: Array<InvoiceCheck>;
  shipping?: Maybe<FillTriangularTransactionShipping>;
};

export type FillTriangularTransactionShipping = {
  __typename?: 'FillTriangularTransactionShipping';
  address: FillTriangularTransactionAddress;
  delivery_rural_area: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type FinancialTransfer = {
  __typename?: 'FinancialTransfer';
  type: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type FinancialTransferOut = {
  __typename?: 'FinancialTransferOut';
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type FinancingDocumentsByBankOut = {
  __typename?: 'FinancingDocumentsByBankOut';
  address_proof: Scalars['Boolean']['output'];
  billing_document: Scalars['Boolean']['output'];
  personal_document: Scalars['Boolean']['output'];
};

export type FinancingIn = {
  bank_code: Scalars['String']['input'];
  bank_name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FindOrderOut = {
  __typename?: 'FindOrderOut';
  actions: Array<Maybe<OrderAction>>;
  available_at?: Maybe<Scalars['String']['output']>;
  available_at_date?: Maybe<Scalars['String']['output']>;
  client_name: Scalars['String']['output'];
  deliveries: Array<OrderDelivery>;
  deliveries_title: Scalars['String']['output'];
  delivery: OrderDetailsDelivery;
  delivery_estimate?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  innova_id?: Maybe<Scalars['Int']['output']>;
  insurances?: Maybe<Array<Maybe<OrderInsurance>>>;
  invoice_info: OrderInvoiceInfo;
  notes: OrderNotes;
  number: Scalars['Int']['output'];
  partially_invoiced: Scalars['Boolean']['output'];
  partner: OrderPartnerInfo;
  payment_method: Scalars['String']['output'];
  pending_payment: Scalars['Boolean']['output'];
  pre_sale: Scalars['Boolean']['output'];
  products: Array<Maybe<OrderDetailsProduct>>;
  schedule_pickup_text?: Maybe<Scalars['String']['output']>;
  summary: Summary;
  timeline: Array<Maybe<OrderDetailsTimeline>>;
  tracking_link?: Maybe<Scalars['String']['output']>;
  triangulation?: Maybe<OrderTriangulation>;
  type: Scalars['String']['output'];
  warranty?: Maybe<OrderWarranty>;
};

export type FindUpsellOut = {
  __typename?: 'FindUpsellOut';
  actual_inverter?: Maybe<InverterUpsellOut>;
  additional_investment?: Maybe<Scalars['Float']['output']>;
  cart_total_current?: Maybe<Scalars['Float']['output']>;
  cart_total_upsell?: Maybe<Scalars['Float']['output']>;
  has_offer: Scalars['Boolean']['output'];
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  upsell_inverter?: Maybe<InverterUpsellOut>;
};

export type FintechSimulationOut = {
  __typename?: 'FintechSimulationOut';
  bill_value?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  down_payment_required?: Maybe<Scalars['Boolean']['output']>;
  grace_period_months?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  max_approved_project_value?: Maybe<Scalars['Float']['output']>;
  max_available_installments?: Maybe<Scalars['Int']['output']>;
  min_approved_project_value?: Maybe<Scalars['Float']['output']>;
  person_type?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_value?: Maybe<Scalars['Float']['output']>;
  representative_document?: Maybe<Scalars['String']['output']>;
  required_down_payment_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ui_result?: Maybe<Scalars['String']['output']>;
};

export type Formalization = {
  __typename?: 'Formalization';
  contract?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  receipt_model?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
};

export type GetAddressOut = {
  __typename?: 'GetAddressOut';
  cep: Scalars['String']['output'];
  city: Scalars['String']['output'];
  ibge_code: Scalars['String']['output'];
  neighborhood: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type GetByFintechIdOut = {
  __typename?: 'GetByFintechIdOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Query_GetCartByFintechId_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Query_GetCartByFintechId_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Query_GetCartByFintechId_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Query_GetCartByFintechId_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type GetByFintechIdOut404 = {
  __typename?: 'GetByFintechIdOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetByIdOut = {
  __typename?: 'GetByIdOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Query_GetCartById_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_coverage_years?: Maybe<Scalars['Int']['output']>;
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  internal_order_id?: Maybe<Scalars['String']['output']>;
  inverters?: Maybe<Array<Maybe<Inverter>>>;
  items?: Maybe<Array<Maybe<CartItemOut>>>;
  modules?: Maybe<Array<Maybe<Module>>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Query_GetCartById_OneOf_0_Payment>;
  payment_details?: Maybe<PaymentDetails>;
  payment_link?: Maybe<Scalars['String']['output']>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Query_GetCartById_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Query_GetCartById_OneOf_0_Shipping>;
  status: StatusOut;
  subregion?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
  summary?: Maybe<Summary>;
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GetByIdOut404 = {
  __typename?: 'GetByIdOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetByPartnerIdOut = {
  __typename?: 'GetByPartnerIdOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Query_GetCartByPartner_OneOf_0_Buyer>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Query_GetCartByPartner_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  financial_transfer?: Maybe<FinancialTransferOut>;
  financial_transfer_enabled?: Maybe<Scalars['Boolean']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_coverage_years?: Maybe<Scalars['Int']['output']>;
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  internal_order_id?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<CartItemOut>>>;
  manual_discount?: Maybe<Scalars['Float']['output']>;
  max_value_financial_transfer?: Maybe<Scalars['String']['output']>;
  max_value_manual_discount?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Query_GetCartByPartner_OneOf_0_Payment>;
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  payment_details?: Maybe<PaymentDetails>;
  payment_link?: Maybe<Scalars['String']['output']>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  products?: Maybe<Array<Maybe<CartSpareProductsOut>>>;
  proposal?: Maybe<Query_GetCartByPartner_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Query_GetCartByPartner_OneOf_0_Shipping>;
  should_confirm_on_add_kit?: Maybe<Scalars['Boolean']['output']>;
  status: StatusOut;
  subregion?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
  summary?: Maybe<Summary>;
  total: Scalars['Float']['output'];
  totalWithComboFacil?: Maybe<Scalars['String']['output']>;
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GetByPartnerIdOut404 = {
  __typename?: 'GetByPartnerIdOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCustomCartOut = {
  __typename?: 'GetCustomCartOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  big_numbers?: Maybe<Array<Maybe<BigNumber>>>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Query_GetCustomCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Query_GetCustomCart_OneOf_0_Payment>;
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  product_total?: Maybe<Scalars['Float']['output']>;
  proposal?: Maybe<Query_GetCustomCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  reference_description?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Query_GetCustomCart_OneOf_0_Shipping>;
  status: StatusOut;
  subregion?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
  summary?: Maybe<Summary>;
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GetCustomCartOut404 = {
  __typename?: 'GetCustomCartOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCustomKitOffersAlert = {
  __typename?: 'GetCustomKitOffersAlert';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCustomKitOffersOut = {
  __typename?: 'GetCustomKitOffersOut';
  alert?: Maybe<GetCustomKitOffersAlert>;
  offers: Array<CustomKitOffer>;
};

export type GetCustomKitOffersV2Out = {
  __typename?: 'GetCustomKitOffersV2Out';
  alert?: Maybe<GetCustomKitOffersAlert>;
  offers: Array<CustomKitOfferV2>;
};

export type GetEligibleFinancingOut = {
  __typename?: 'GetEligibleFinancingOut';
  data?: Maybe<Array<Maybe<EligibleFinancing>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetInvoiceInfoOut = {
  __typename?: 'GetInvoiceInfoOut';
  invoiceChecks: Array<InvoiceCheck>;
  invoiceMessage: InvoiceMessage;
  invoiceModalChecks: Array<InvoiceModalCheck>;
};

export type GetOrderDetailsOut = {
  __typename?: 'GetOrderDetailsOut';
  actions: Array<Maybe<OrderAction>>;
  available_at?: Maybe<Scalars['String']['output']>;
  available_at_date?: Maybe<Scalars['String']['output']>;
  client_name: Scalars['String']['output'];
  deliveries: Array<OrderDelivery>;
  deliveries_title: Scalars['String']['output'];
  delivery: OrderDetailsDelivery;
  delivery_estimate?: Maybe<Scalars['String']['output']>;
  documents: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  insurances?: Maybe<Array<Maybe<OrderInsurance>>>;
  notes: OrderNotes;
  number: Scalars['Int']['output'];
  partially_invoiced: Scalars['Boolean']['output'];
  payment_method: Scalars['String']['output'];
  pending_payment: Scalars['Boolean']['output'];
  pre_sale: Scalars['Boolean']['output'];
  products?: Maybe<Array<Maybe<OrderDetailsProduct>>>;
  schedule_pickup_text?: Maybe<Scalars['String']['output']>;
  spare_products?: Maybe<Array<Maybe<CartSpareProductsOut>>>;
  summary: Summary;
  timeline: Array<Maybe<OrderDetailsTimeline>>;
  tracking_link?: Maybe<Scalars['String']['output']>;
  triangulation?: Maybe<OrderTriangulation>;
  type: Scalars['String']['output'];
  warranty?: Maybe<OrderWarranty>;
};

export type GetOrdersListOut = {
  __typename?: 'GetOrdersListOut';
  data: Array<Maybe<OrderListing>>;
  meta: Pagination;
};

export type GetPartnersOut = {
  __typename?: 'GetPartnersOut';
  partners?: Maybe<Array<Maybe<Partner>>>;
};

export type GetPaymentInfoDetailOut = {
  __typename?: 'GetPaymentInfoDetailOut';
  expiration_date?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type GetPaymentInfoOut = {
  __typename?: 'GetPaymentInfoOut';
  detail?: Maybe<GetPaymentInfoDetailOut>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GetPaymentLinkOut = {
  __typename?: 'GetPaymentLinkOut';
  link: Scalars['String']['output'];
};

export type GetProposalsOut = {
  __typename?: 'GetProposalsOut';
  meta: ProposalMetaOut;
  proposals: Array<Maybe<CartOut>>;
};

export type GetShippingOptionFobContent = {
  __typename?: 'GetShippingOptionFOBContent';
  distribution_center_name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tooltip: Scalars['String']['output'];
  withdrawal_text: Scalars['String']['output'];
};

export type GetShippingOptionOut = {
  __typename?: 'GetShippingOptionOut';
  content?: Maybe<GetShippingOptionOutContent>;
  enabled: Scalars['Boolean']['output'];
  icon: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GetShippingOptionOutContent = GetShippingOptionFobContent | Shipping;

export type GetSpareProductsAssortmentInfoOut = {
  __typename?: 'GetSpareProductsAssortmentInfoOut';
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GetSpareProductsAssortmentOut = {
  __typename?: 'GetSpareProductsAssortmentOut';
  available_at?: Maybe<Scalars['Date']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  in_cart?: Maybe<Scalars['Boolean']['output']>;
  info?: Maybe<Array<Maybe<GetSpareProductsAssortmentInfoOut>>>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  pre_sale?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CartItemStatusOut>;
  total_price?: Maybe<Scalars['Float']['output']>;
};

export type GetSpareProductsCartOut = {
  __typename?: 'GetSpareProductsCartOut';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  should_confirm_on_add?: Maybe<Scalars['Boolean']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type GetSpareProductsFacetsOptionsOut = {
  __typename?: 'GetSpareProductsFacetsOptionsOut';
  name?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GetSpareProductsFacetsOut = {
  __typename?: 'GetSpareProductsFacetsOut';
  filter_name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<GetSpareProductsFacetsOptionsOut>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GetSpareProductsMetaOut = {
  __typename?: 'GetSpareProductsMetaOut';
  count?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type GetSpareProductsOut = {
  __typename?: 'GetSpareProductsOut';
  cart?: Maybe<GetSpareProductsCartOut>;
  facets?: Maybe<Array<Maybe<GetSpareProductsFacetsOut>>>;
  meta?: Maybe<GetSpareProductsMetaOut>;
  product_filters?: Maybe<Array<Maybe<ListProductOutputFacet>>>;
  products?: Maybe<Array<Maybe<GetSpareProductsAssortmentOut>>>;
};

export type GetUserFeatureFlagsOut = {
  __typename?: 'GetUserFeatureFlagsOut';
  customKitOfferV2: Scalars['Boolean']['output'];
  customKitOffers: Scalars['Boolean']['output'];
  distributionCenterIdsWithHvacSell: Array<Scalars['Int']['output']>;
  enableFintechSimulation: Scalars['Boolean']['output'];
  hideComboFacil: Scalars['Boolean']['output'];
  hvacCategoryHighlightEnabled: Scalars['Boolean']['output'];
  multiCd: Scalars['Boolean']['output'];
  multiYearInsurance: Scalars['Boolean']['output'];
  triangularTransaction: Scalars['Boolean']['output'];
};

export type GetUsersOut = {
  __typename?: 'GetUsersOut';
  users?: Maybe<Array<Maybe<User>>>;
};

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type HttpValidationError = {
  __typename?: 'HTTPValidationError';
  detail?: Maybe<Array<Maybe<ValidationError>>>;
};

export type Image = {
  __typename?: 'Image';
  main?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export type ImageModel = {
  __typename?: 'ImageModel';
  description?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageOut = {
  __typename?: 'ImageOut';
  url: Scalars['String']['output'];
};

export type Image_Input = {
  main?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type Impersonate_Id = {
  __typename?: 'Impersonate_Id';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type IndexKitsIn_Input = {
  kits: Array<InputMaybe<Kit_Input>>;
};

export type IndexKitsOut = {
  __typename?: 'IndexKitsOut';
  errors: Array<Maybe<Scalars['JSON']['output']>>;
  total_errors: Scalars['Int']['output'];
  total_kits_indexed: Scalars['Int']['output'];
};

export type Info = {
  __typename?: 'Info';
  JSON?: Maybe<Scalars['JSON']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
  cell_type?: Maybe<Scalars['String']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  network_type?: Maybe<Scalars['String']['output']>;
};

export type InstallmentPlanIn = {
  amount: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type Insurance = {
  __typename?: 'Insurance';
  Float?: Maybe<Scalars['Float']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type InsuranceQuotationOut = {
  __typename?: 'InsuranceQuotationOut';
  annual_total: Scalars['Float']['output'];
  coverage_years: Scalars['Int']['output'];
  default: Scalars['Boolean']['output'];
  discount_percentage?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Internal = {
  __typename?: 'Internal';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Inversor = {
  __typename?: 'Inversor';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Inverter = {
  __typename?: 'Inverter';
  amount?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  electric_connection?: Maybe<Scalars['String']['output']>;
  info?: Maybe<ModuleInfo>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type InverterInfo = {
  __typename?: 'InverterInfo';
  cell_type?: Maybe<Scalars['String']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  network_type?: Maybe<Scalars['String']['output']>;
};

export type InverterUpsellOut = {
  __typename?: 'InverterUpsellOut';
  amount?: Maybe<Scalars['Int']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Inverter_Input = {
  amount: Scalars['Int']['input'];
  brand: Scalars['String']['input'];
  datasheet: Scalars['String']['input'];
  electric_connection: Scalars['String']['input'];
  model: Scalars['String']['input'];
  power: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type InvoiceCheck = {
  __typename?: 'InvoiceCheck';
  description: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InvoiceMessage = {
  __typename?: 'InvoiceMessage';
  company: Scalars['String']['output'];
  customer: Scalars['String']['output'];
  invoice: Scalars['String']['output'];
};

export type InvoiceModalCheck = {
  __typename?: 'InvoiceModalCheck';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ItemIn_Input = {
  amount: Scalars['Int']['input'];
  previous_sku?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type Kit = {
  __typename?: 'Kit';
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  details?: Maybe<Array<Maybe<Detail>>>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  inverters: Array<Maybe<Inverter>>;
  marketable: Scalars['Boolean']['output'];
  modules: Array<Maybe<Module>>;
  power: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  price_from?: Maybe<Scalars['Float']['output']>;
  price_raw?: Maybe<Scalars['Float']['output']>;
  seller: Seller;
  sku: Scalars['String']['output'];
  solfacil_plus?: Maybe<SolFacilPlus>;
  sorting_priority: Scalars['Int']['output'];
  structure: Structure;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type KitModel = {
  __typename?: 'KitModel';
  code: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  dc_id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  discount_rate?: Maybe<Scalars['Float']['output']>;
  images: Array<Maybe<ImageModel>>;
  inverters?: Maybe<Array<Maybe<Inverter>>>;
  marketable: Scalars['Boolean']['output'];
  modules?: Maybe<Array<Maybe<Module>>>;
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  power: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  price_from: Scalars['Float']['output'];
  price_raw: Scalars['Float']['output'];
  price_with_discount?: Maybe<Scalars['Float']['output']>;
  price_with_shipping_fee?: Maybe<Scalars['Float']['output']>;
  products: Array<Maybe<Product>>;
  region: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  solfacil_plus?: Maybe<SolfacilPlus>;
  structure?: Maybe<Structure>;
  updated_at: Scalars['String']['output'];
};

export type Kit_Input = {
  code: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  details?: InputMaybe<Array<InputMaybe<Detail_Input>>>;
  discount_rate?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<InputMaybe<Image_Input>>>;
  inverters: Array<InputMaybe<Inverter_Input>>;
  marketable: Scalars['Boolean']['input'];
  modules: Array<InputMaybe<Module_Input>>;
  power: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  price_raw?: InputMaybe<Scalars['Float']['input']>;
  seller: Seller_Input;
  sku: Scalars['String']['input'];
  solfacil_plus?: InputMaybe<SolFacilPlus_Input>;
  sorting_priority: Scalars['Int']['input'];
  structure: Structure_Input;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

export type Legacy_Id = {
  __typename?: 'Legacy_Id';
  Int?: Maybe<Scalars['Int']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type LinkProduct = {
  __typename?: 'LinkProduct';
  category?: Maybe<Category>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ListCitiesByRegionOut = {
  __typename?: 'ListCitiesByRegionOut';
  cities: Array<CityOut>;
  region: Scalars['String']['output'];
};

export type ListCouponsOut = {
  __typename?: 'ListCouponsOut';
  data: Array<Maybe<ListCouponsOutData>>;
  meta: ListCouponsOutMeta;
};

export type ListCouponsOutData = {
  __typename?: 'ListCouponsOutData';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ListCouponsOutMeta = {
  __typename?: 'ListCouponsOutMeta';
  count: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type ListFinancingBanksOut = {
  __typename?: 'ListFinancingBanksOut';
  data?: Maybe<Array<Maybe<ListFinancingBanksOutItem>>>;
  meta: ListFinancingBanksOutMeta;
};

export type ListFinancingBanksOutItem = {
  __typename?: 'ListFinancingBanksOutItem';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ListFinancingBanksOutMeta = {
  __typename?: 'ListFinancingBanksOutMeta';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type ListOrdersBackofficeOut = {
  __typename?: 'ListOrdersBackofficeOut';
  data: Array<Maybe<ListOrdersBackofficeOutData>>;
  facets: Array<Maybe<ListOrdersBackofficeOutFacet>>;
  meta: ListOrdersBackofficeOutMeta;
};

export type ListOrdersBackofficeOutData = {
  __typename?: 'ListOrdersBackofficeOutData';
  actions: Array<Maybe<OrderAction>>;
  client_name: Scalars['String']['output'];
  creation_date: Scalars['String']['output'];
  deliveries: Array<OrderDelivery>;
  has_battery?: Maybe<Scalars['Boolean']['output']>;
  has_hybrid_inverter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  innova_id?: Maybe<Scalars['Int']['output']>;
  number: Scalars['Int']['output'];
  partner_cnpj?: Maybe<Scalars['String']['output']>;
  partner_name?: Maybe<Scalars['String']['output']>;
  payment_method: Scalars['String']['output'];
  request_made_date?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<Scalars['String']['output']>;
  status: ListOrdersBackofficeOutStatus;
  total_value: Scalars['String']['output'];
  tracking_link?: Maybe<Scalars['String']['output']>;
};

export type ListOrdersBackofficeOutFacet = {
  __typename?: 'ListOrdersBackofficeOutFacet';
  filter_name: Scalars['String']['output'];
  options: Array<Maybe<ListOrdersBackofficeOutFacetOption>>;
  title: Scalars['String']['output'];
};

export type ListOrdersBackofficeOutFacetOption = {
  __typename?: 'ListOrdersBackofficeOutFacetOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ListOrdersBackofficeOutMeta = {
  __typename?: 'ListOrdersBackofficeOutMeta';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type ListOrdersBackofficeOutStatus = {
  __typename?: 'ListOrdersBackofficeOutStatus';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type ListOrdersOut = {
  __typename?: 'ListOrdersOut';
  data: Array<Maybe<ListOrdersOutData>>;
  facets: Array<Maybe<ListOrdersOutFacet>>;
  meta: ListOrdersOutMeta;
};

export type ListOrdersOutData = {
  __typename?: 'ListOrdersOutData';
  actions: Array<Maybe<OrderAction>>;
  client_name: Scalars['String']['output'];
  creation_date: Scalars['String']['output'];
  deliveries: Array<OrderDelivery>;
  has_battery?: Maybe<Scalars['Boolean']['output']>;
  has_hybrid_inverter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  payment_method: Scalars['String']['output'];
  status: ListOrdersOutStatus;
  total_value: Scalars['String']['output'];
  tracking_link?: Maybe<Scalars['String']['output']>;
};

export type ListOrdersOutFacet = {
  __typename?: 'ListOrdersOutFacet';
  filter_name: Scalars['String']['output'];
  options: Array<Maybe<ListOrdersOutFacetOption>>;
  title: Scalars['String']['output'];
};

export type ListOrdersOutFacetOption = {
  __typename?: 'ListOrdersOutFacetOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ListOrdersOutMeta = {
  __typename?: 'ListOrdersOutMeta';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type ListOrdersOutStatus = {
  __typename?: 'ListOrdersOutStatus';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type ListProductOutputFacet = {
  __typename?: 'ListProductOutputFacet';
  filter_name: Scalars['String']['output'];
  options: Array<Maybe<ListProductOutputFacetItem>>;
  title: Scalars['String']['output'];
};

export type ListProductOutputFacetItem = {
  __typename?: 'ListProductOutputFacetItem';
  count: Scalars['Int']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type Meta = {
  __typename?: 'Meta';
  count?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type MetaOut = {
  __typename?: 'MetaOut';
  count?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type MethodIn_Input = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type MethodOut = {
  __typename?: 'MethodOut';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Module = {
  __typename?: 'Module';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  info?: Maybe<ModuleInfo>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ModuleInfo = {
  __typename?: 'ModuleInfo';
  cell_type?: Maybe<Scalars['String']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  network_type?: Maybe<Scalars['String']['output']>;
};

export type Module_Input = {
  amount: Scalars['Int']['input'];
  brand: Scalars['String']['input'];
  datasheet: Scalars['String']['input'];
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  power?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUpsell?: Maybe<GetCustomCartOut>;
  addCouponCart?: Maybe<AddCouponOut>;
  addCouponCustomers?: Maybe<AddCouponCustomersOut>;
  addCouponProducts?: Maybe<AddCouponProductsOut>;
  addFinancialTransfer?: Maybe<AddFinancialTransferOut>;
  addInsuranceCart?: Maybe<AddInsuranceOut>;
  addManualDiscount?: Maybe<AddManualDiscountOut>;
  addProductCart?: Maybe<AddProductOut>;
  addProductCustomCart?: Maybe<AddProductCustomCartOut>;
  adjustCart?: Maybe<AdjustCartOut>;
  adjustItemCart?: Maybe<AdjustItemOut>;
  adjustSpareProductCart?: Maybe<GetByIdOut>;
  assembleKit?: Maybe<AssembleKitOut>;
  assembleKitV2?: Maybe<AssembleKitV2Out>;
  cancelOrder?: Maybe<CancelOrderOut>;
  changeShippingType?: Maybe<ChangeShippingTypeOut>;
  clearCart?: Maybe<ClearOut>;
  closeOrder?: Maybe<GetByPartnerIdOut>;
  completeCustomCart?: Maybe<CompleteCustomCartOut>;
  convertToProposal?: Maybe<ConvertToProposalOut>;
  createCounteroffer?: Maybe<CreateCounterofferOut>;
  createCoupon?: Maybe<CreateCouponOut>;
  createCustomCart?: Maybe<CreateCustomCartOut>;
  createFintechSimulation?: Maybe<FintechSimulationOut>;
  /** Create New Order */
  createOrder?: Maybe<CreateOrder_Response>;
  createOrderDeliveryInvoices?: Maybe<CreateOrderInvoiceOut>;
  /** Create Order Flow */
  createOrderFlow?: Maybe<CreateOrderFlow_Response>;
  createOrderInvoice?: Maybe<CreateOrderInvoiceOut>;
  createOrderMirrorById?: Maybe<CreateOrderMirrorByIdOut>;
  createProposalSheetById?: Maybe<CreateProposalSheetByIdOut>;
  createProposalsSheet?: Maybe<CreateProposalsSheetOut>;
  deactivateCoupon?: Maybe<Scalars['String']['output']>;
  fillPaymentCart?: Maybe<AdjustCartOut>;
  fillPaymentCartV2?: Maybe<GetByPartnerIdOut>;
  fillShippingCart?: Maybe<FillShippingOut>;
  fillShippingCartV2?: Maybe<GetByPartnerIdOut>;
  fillTriangularTransaction?: Maybe<FillTriangularTransactionOut>;
  linkCartIntoFinancing?: Maybe<Scalars['Boolean']['output']>;
  removeAllProductsCart?: Maybe<GetByIdOut>;
  removeCouponCustomers?: Maybe<RemoveCouponCustomersOut>;
  removeCouponProducts?: Maybe<RemoveCouponProductsOut>;
  removeFinancialTransfer?: Maybe<RemoveFinancialTransferOut>;
  removeInsuranceCart?: Maybe<RemoveInsuranceOut>;
  removeProductCart?: Maybe<Scalars['String']['output']>;
  removeShipping?: Maybe<GetByPartnerIdOut>;
  removeTriangularTransaction?: Maybe<RemoveTriangularTransactionOut>;
  shippingDetails?: Maybe<GetByPartnerIdOut>;
  updateCoupon?: Maybe<UpdateCouponOut>;
  updateCouponCustomer?: Maybe<UpdateCouponCustomerOut>;
  /** Update Order Flow */
  updateOrderFlowStatus?: Maybe<UpdateOrderFlowStatus_Response>;
  /** Update Order Status */
  updateOrderStatus?: Maybe<UpdateOrderStatus_Response>;
  updateSubregion?: Maybe<GetByPartnerIdOut>;
};


export type MutationAcceptUpsellArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationAddCouponCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<AddCouponInRoute_Input>;
};


export type MutationAddCouponCustomersArgs = {
  input: AddCouponCustomersInput;
  name: Scalars['String']['input'];
};


export type MutationAddCouponProductsArgs = {
  input: AddCouponProductsInput;
  name: Scalars['String']['input'];
};


export type MutationAddFinancialTransferArgs = {
  cart_id: Scalars['UUID']['input'];
  input: AddFinancialTransferInRoute_Input;
};


export type MutationAddInsuranceCartArgs = {
  cart_id: Scalars['UUID']['input'];
  coverage_years?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddManualDiscountArgs = {
  cart_id: Scalars['UUID']['input'];
  input: AddManualDiscountInRoute_Input;
};


export type MutationAddProductCartArgs = {
  input?: InputMaybe<AddProductInRoute_Input>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddProductCustomCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<AddProductCustomCartInRoute_Input>;
};


export type MutationAdjustCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<AdjustCartInRoute_Input>;
};


export type MutationAdjustItemCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<AdjustItemInRoute_Input>;
  sku: Scalars['String']['input'];
};


export type MutationAdjustSpareProductCartArgs = {
  cart_id?: InputMaybe<Scalars['UUID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  dc_id?: InputMaybe<Scalars['Int']['input']>;
  item: AdjustSpareProductItemIn;
  region?: InputMaybe<Scalars['String']['input']>;
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssembleKitArgs = {
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  inverter_manufacturer?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  inverter_type?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  structure_installation?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssembleKitV2Args = {
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  items: Array<AssembleKitV2ItemInput>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrderArgs = {
  cancelation_reason?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['String']['input'];
};


export type MutationChangeShippingTypeArgs = {
  cart_id: Scalars['UUID']['input'];
  shipping_type: Scalars['String']['input'];
};


export type MutationClearCartArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationCloseOrderArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<CloseOrderInRoute_Input>;
};


export type MutationCompleteCustomCartArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationConvertToProposalArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationCreateCounterofferArgs = {
  input: CreateCounterofferInRoute_Input;
  partner_id: Scalars['Int']['input'];
};


export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationCreateCustomCartArgs = {
  input?: InputMaybe<CreateCustomCartInRoute_Input>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateFintechSimulationArgs = {
  cart_id: Scalars['UUID']['input'];
  input: CreateFintechSimulationInput;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<CreateOrderInRoute_Input>;
};


export type MutationCreateOrderDeliveryInvoicesArgs = {
  order_id: Scalars['String']['input'];
};


export type MutationCreateOrderFlowArgs = {
  order_flow_type: OrderFlowTypeEnum;
  order_id: Scalars['UUID']['input'];
};


export type MutationCreateOrderInvoiceArgs = {
  delivery_id?: InputMaybe<Scalars['String']['input']>;
  only_base_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  order_id: Scalars['String']['input'];
};


export type MutationCreateOrderMirrorByIdArgs = {
  order_id: Scalars['String']['input'];
};


export type MutationCreateProposalSheetByIdArgs = {
  proposal_id: Scalars['UUID']['input'];
};


export type MutationCreateProposalsSheetArgs = {
  begin_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateCouponArgs = {
  name: Scalars['String']['input'];
};


export type MutationFillPaymentCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<FillPaymentInRoute_Input>;
};


export type MutationFillPaymentCartV2Args = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<FillPaymentV2InRoute_Input>;
};


export type MutationFillShippingCartArgs = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<FillShippingInRoute_Input>;
};


export type MutationFillShippingCartV2Args = {
  cart_id: Scalars['UUID']['input'];
  input?: InputMaybe<FillShippingV2InRoute_Input>;
};


export type MutationFillTriangularTransactionArgs = {
  cart_id: Scalars['UUID']['input'];
  input: FillTriangularTransactionInRoute_Input;
};


export type MutationLinkCartIntoFinancingArgs = {
  cart_id: Scalars['String']['input'];
  project_id: Scalars['UUID']['input'];
};


export type MutationRemoveAllProductsCartArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationRemoveCouponCustomersArgs = {
  input: RemoveCouponCustomersInput;
  name: Scalars['String']['input'];
};


export type MutationRemoveCouponProductsArgs = {
  input: RemoveCouponProductsInput;
  name: Scalars['String']['input'];
};


export type MutationRemoveFinancialTransferArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationRemoveInsuranceCartArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationRemoveProductCartArgs = {
  cart_id: Scalars['UUID']['input'];
  sku: Scalars['String']['input'];
};


export type MutationRemoveShippingArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationRemoveTriangularTransactionArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type MutationShippingDetailsArgs = {
  cart_id: Scalars['UUID']['input'];
  cep: Scalars['String']['input'];
};


export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput;
  name: Scalars['String']['input'];
};


export type MutationUpdateCouponCustomerArgs = {
  cnpj: Scalars['String']['input'];
  input: UpdateCouponCustomerInput;
  name: Scalars['String']['input'];
};


export type MutationUpdateOrderFlowStatusArgs = {
  input?: InputMaybe<UpdateOrderFlowIn_Input>;
  order_flow_type: OrderFlowTypeEnum;
  order_id: Scalars['UUID']['input'];
};


export type MutationUpdateOrderStatusArgs = {
  input?: InputMaybe<UpdateOrderStatusIn_Input>;
  order_id: Scalars['UUID']['input'];
};


export type MutationUpdateSubregionArgs = {
  cart_id: Scalars['UUID']['input'];
  subregion: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type Neighborhood = {
  __typename?: 'Neighborhood';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Notes = {
  billing_note?: InputMaybe<Scalars['String']['input']>;
  payment_note?: InputMaybe<Scalars['String']['input']>;
};

export type Number = {
  __typename?: 'Number';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type OperatingAgreement = {
  __typename?: 'OperatingAgreement';
  can_accept: Scalars['Boolean']['output'];
  is_current_term_accepted: Scalars['Boolean']['output'];
};

export type Opportunity = {
  __typename?: 'Opportunity';
  enableNextLevel?: Maybe<Scalars['Boolean']['output']>;
  nextLevel?: Maybe<Scalars['Int']['output']>;
  scoreForThisPurchase?: Maybe<Scalars['Int']['output']>;
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Address>;
  combo?: Maybe<Combo>;
  created_at: Scalars['DateTime']['output'];
  customer?: Maybe<Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Customer>;
  discount?: Maybe<Discount>;
  items?: Maybe<Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Items>;
  order_id: Scalars['Int']['output'];
  partner?: Maybe<Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Partner>;
  power?: Maybe<Power>;
  raw_total: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type OrderAction = {
  __typename?: 'OrderAction';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export enum OrderChannel {
  Auto = 'AUTO',
  Portal = 'PORTAL'
}

export type OrderChannelDto = {
  __typename?: 'OrderChannelDTO';
  channel: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type OrderChannelDto_Input = {
  channel: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type OrderCustomerDto = {
  __typename?: 'OrderCustomerDTO';
  billing_type?: Maybe<Billing_Type>;
  city?: Maybe<City>;
  company_name?: Maybe<Company_Name>;
  complement?: Maybe<Complement>;
  document_number: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  neighborhood?: Maybe<Neighborhood>;
  number?: Maybe<Number>;
  phone: Scalars['String']['output'];
  state?: Maybe<State>;
  state_registration?: Maybe<State_Registration>;
  street?: Maybe<Street>;
  type: Scalars['String']['output'];
  zip_code?: Maybe<Zip_Code>;
};

export type OrderCustomerDto_Input = {
  billing_type?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['JSON']['input']>;
  company_name?: InputMaybe<Scalars['JSON']['input']>;
  complement?: InputMaybe<Scalars['JSON']['input']>;
  document_number: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  neighborhood?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<Scalars['JSON']['input']>;
  phone: Scalars['String']['input'];
  state?: InputMaybe<Scalars['JSON']['input']>;
  state_registration?: InputMaybe<Scalars['JSON']['input']>;
  street?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  zip_code?: InputMaybe<Scalars['JSON']['input']>;
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  erp_protheus_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_serie?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  tracking_link?: Maybe<Scalars['String']['output']>;
};

export type OrderDetailsAddress = {
  __typename?: 'OrderDetailsAddress';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  rural_zone?: Maybe<Scalars['Boolean']['output']>;
  street: Scalars['String']['output'];
  zip_code: Scalars['String']['output'];
};

export type OrderDetailsDelivery = {
  __typename?: 'OrderDetailsDelivery';
  address: OrderDetailsAddress;
  max_delivery_days?: Maybe<Scalars['Int']['output']>;
  min_delivery_days?: Maybe<Scalars['Int']['output']>;
  recipient?: Maybe<OrderDetailsRecipient>;
  type: Scalars['String']['output'];
};

export type OrderDetailsProduct = {
  __typename?: 'OrderDetailsProduct';
  description: Scalars['String']['output'];
  details: Array<Maybe<OrderDetailsProductDetail>>;
  image?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type OrderDetailsProductDescription = {
  __typename?: 'OrderDetailsProductDescription';
  amount: Scalars['Int']['output'];
  datasheet?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type OrderDetailsProductDetail = {
  __typename?: 'OrderDetailsProductDetail';
  category: Scalars['String']['output'];
  descriptions: Array<Maybe<OrderDetailsProductDescription>>;
};

export type OrderDetailsRecipient = {
  __typename?: 'OrderDetailsRecipient';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderDetailsTimeline = {
  __typename?: 'OrderDetailsTimeline';
  completed: Scalars['Boolean']['output'];
  current: Scalars['Boolean']['output'];
  error: Scalars['Boolean']['output'];
  informative: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  warning: Scalars['Boolean']['output'];
};

export type OrderFlowDto = {
  __typename?: 'OrderFlowDTO';
  flow_type: OrderFlowTypeEnum;
  status: OrderFlowStatusDto;
};

export type OrderFlowStatusDto = {
  __typename?: 'OrderFlowStatusDTO';
  current: OrderFlowStatusEnum;
  history: Array<Maybe<OrderFlowStatusHistoryDto>>;
};

export enum OrderFlowStatusEnum {
  Analysing = 'ANALYSING',
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Paid = 'PAID',
  PendingReproved = 'PENDING_REPROVED',
  Reproved = 'REPROVED'
}

export type OrderFlowStatusHistoryDto = {
  __typename?: 'OrderFlowStatusHistoryDTO';
  created_at: Scalars['DateTime']['output'];
  reason: Reason;
  status: OrderFlowStatusEnum;
};

export enum OrderFlowTypeEnum {
  Cancelation = 'CANCELATION',
  Payment = 'PAYMENT'
}

export type OrderInsurance = {
  __typename?: 'OrderInsurance';
  coverage_years?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OrderInvoiceInfo = {
  __typename?: 'OrderInvoiceInfo';
  customer_document: Scalars['String']['output'];
  customer_email: Scalars['String']['output'];
  customer_name: Scalars['String']['output'];
  customer_phone: Scalars['String']['output'];
  customer_state_registration?: Maybe<Scalars['String']['output']>;
  customer_type: Scalars['String']['output'];
  invoice_address: Scalars['String']['output'];
};

export type OrderItemDto = {
  __typename?: 'OrderItemDTO';
  available_at?: Maybe<Available_At>;
  description: Scalars['String']['output'];
  item_id: Scalars['String']['output'];
  parent_item_id?: Maybe<Parent_Item_Id>;
  power?: Maybe<Power>;
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type OrderItemDto_Input = {
  available_at?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  item_id: Scalars['String']['input'];
  parent_item_id?: InputMaybe<Scalars['JSON']['input']>;
  power?: InputMaybe<Scalars['JSON']['input']>;
  quantity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type OrderListing = {
  __typename?: 'OrderListing';
  creation_date: Scalars['DateTime']['output'];
  end_customer_name: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  order_flows: Array<Maybe<OrderFlowDto>>;
  order_number: Scalars['Int']['output'];
  order_type: Scalars['String']['output'];
  partner_id: Scalars['Int']['output'];
  payment_origin: Scalars['String']['output'];
  status: Scalars['String']['output'];
  total_value: Scalars['Float']['output'];
};

export type OrderNotes = {
  __typename?: 'OrderNotes';
  internal?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
};

export type OrderPartnerInfo = {
  __typename?: 'OrderPartnerInfo';
  corporate_name: Scalars['String']['output'];
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state_registration?: Maybe<Scalars['String']['output']>;
  trade_name: Scalars['String']['output'];
};

export type OrderPartnerVolume = {
  __typename?: 'OrderPartnerVolume';
  document: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type OrderPaymentDto = {
  __typename?: 'OrderPaymentDTO';
  origin: OrderPaymentTypeEnum;
  value: Scalars['Float']['output'];
};

export type OrderPaymentDto_Input = {
  origin: OrderPaymentTypeEnum;
  value: Scalars['Float']['input'];
};

export enum OrderPaymentTypeEnum {
  Avista = 'AVISTA',
  Boleto = 'BOLETO',
  CreditCard = 'CREDIT_CARD',
  FinancialSolfacil = 'FINANCIAL_SOLFACIL',
  Financing = 'FINANCING',
  Pix = 'PIX'
}

export type OrderPricingDto = {
  __typename?: 'OrderPricingDTO';
  origin: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  reference_id?: Maybe<Reference_Id>;
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type OrderPricingDto_Input = {
  origin: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  reference_id?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type OrderShippingDto = {
  __typename?: 'OrderShippingDTO';
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Complement>;
  freight_type: Scalars['String']['output'];
  freight_value?: Maybe<Scalars['Float']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  rural_zone?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type OrderShippingDto_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['JSON']['input']>;
  freight_type: Scalars['String']['input'];
  freight_value?: InputMaybe<Scalars['Float']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  rural_zone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderStatus {
  Analysing = 'ANALYSING',
  Approved = 'APPROVED',
  Approving = 'APPROVING',
  AwaitAvailable = 'AWAIT_AVAILABLE',
  AwaitDocumentFinancing = 'AWAIT_DOCUMENT_FINANCING',
  AwaitFinishedFinancing = 'AWAIT_FINISHED_FINANCING',
  AwaitMade = 'AWAIT_MADE',
  AwaitProduct = 'AWAIT_PRODUCT',
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Dealing = 'DEALING',
  Disapproved = 'DISAPPROVED',
  Dispatched = 'DISPATCHED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Financing = 'FINANCING',
  Finished = 'FINISHED',
  FinishedFinancing = 'FINISHED_FINANCING',
  Made = 'MADE',
  Missing = 'MISSING',
  NoteCreated = 'NOTE_CREATED',
  Open = 'OPEN',
  PartialBilling = 'PARTIAL_BILLING',
  Paying = 'PAYING',
  PendingCanceling = 'PENDING_CANCELING',
  ProcessingTransfer = 'PROCESSING_TRANSFER',
  Returned = 'RETURNED'
}

export type OrderStatusDto = {
  __typename?: 'OrderStatusDTO';
  current: Scalars['String']['output'];
  history?: Maybe<Array<Maybe<OrderStatusHistoryDto>>>;
};

export enum OrderStatusEnum {
  Approval = 'APPROVAL',
  Canceled = 'CANCELED',
  Delivery = 'DELIVERY',
  Disapproved = 'DISAPPROVED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  Integrated = 'INTEGRATED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Payment = 'PAYMENT',
  PendingCancelation = 'PENDING_CANCELATION',
  PendingIntegration = 'PENDING_INTEGRATION',
  Returned = 'RETURNED',
  Separation = 'SEPARATION',
  WaitingProduct = 'WAITING_PRODUCT'
}

export type OrderStatusHistoryDto = {
  __typename?: 'OrderStatusHistoryDTO';
  created_at: Scalars['DateTime']['output'];
  reason?: Maybe<Reason>;
  status: Scalars['String']['output'];
};

export type OrderTriangulation = {
  __typename?: 'OrderTriangulation';
  invoice_issue_date?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_serial_number?: Maybe<Scalars['String']['output']>;
};

export enum OrderTypeEnum {
  Closed = 'CLOSED',
  Custom = 'CUSTOM',
  Product = 'PRODUCT'
}

export type OrderUserDto = {
  __typename?: 'OrderUserDTO';
  impersonate_id?: Maybe<Impersonate_Id>;
  partner_cnpj: Scalars['String']['output'];
  partner_id: Scalars['Int']['output'];
  segmentation_id?: Maybe<Segmentation_Id>;
  user_id: Scalars['Int']['output'];
};

export type OrderUserDto_Input = {
  impersonate_id?: InputMaybe<Scalars['JSON']['input']>;
  partner_cnpj: Scalars['String']['input'];
  partner_id: Scalars['Int']['input'];
  segmentation_id?: InputMaybe<Scalars['JSON']['input']>;
  user_id: Scalars['Int']['input'];
};

export type OrderWarranty = {
  __typename?: 'OrderWarranty';
  version?: Maybe<Scalars['Int']['output']>;
};

export type OriginalProposalIn = {
  installment_plan: InstallmentPlanIn;
  inverter_brand: Scalars['String']['input'];
  is_microinverter: Scalars['Boolean']['input'];
  module_brand: Scalars['String']['input'];
  network_type: Scalars['String']['input'];
  power: Scalars['Float']['input'];
  structure_type: Scalars['String']['input'];
  total_value: Scalars['Float']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type Parent_Item_Id = {
  __typename?: 'Parent_Item_Id';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  acceptedCurrentOperatingAgreement?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  cnpj?: Maybe<Scalars['String']['output']>;
  corporateName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  recipient?: Maybe<Recipient>;
  registration_type?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Responsible>;
  state_registration?: Maybe<Scalars['String']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  wholesale?: Maybe<Wholesale>;
};

export type PartnerOut = {
  __typename?: 'PartnerOut';
  address?: Maybe<AddressOut>;
  cnpj?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  impersonated: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  responsible_id?: Maybe<Scalars['Int']['output']>;
  responsible_name?: Maybe<Scalars['String']['output']>;
  solfacil_plus: SolfacilPlusOut;
  state_registration?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  created_at?: Maybe<Scalars['String']['output']>;
  financing_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payment_percentage?: Maybe<Scalars['Int']['output']>;
  total_value?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PaymentCondition = {
  __typename?: 'PaymentCondition';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentConditionInstallmentOut = {
  __typename?: 'PaymentConditionInstallmentOut';
  has_interest: Scalars['Boolean']['output'];
  installmentValue: Scalars['String']['output'];
  installments: Scalars['Int']['output'];
  totalValue: Scalars['String']['output'];
};

export type PaymentConditionOut = {
  __typename?: 'PaymentConditionOut';
  button_text?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  enabled: Scalars['Boolean']['output'];
  final_price?: Maybe<Scalars['String']['output']>;
  installments?: Maybe<Array<Maybe<PaymentConditionInstallmentOut>>>;
  payment_method_id: Scalars['Int']['output'];
  payment_name: Scalars['String']['output'];
};

export type PaymentConditionsOut = {
  __typename?: 'PaymentConditionsOut';
  conditions?: Maybe<Array<Maybe<PaymentConditionsOutItem>>>;
};

export type PaymentConditionsOutItem = {
  __typename?: 'PaymentConditionsOutItem';
  installmentValue: Scalars['String']['output'];
  installments: Scalars['Int']['output'];
  observation: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['String']['output']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  expiration_days?: Maybe<Scalars['Int']['output']>;
  installment_text?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  discount_highlight?: Maybe<Scalars['Boolean']['output']>;
  discount_offer?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  installments?: Maybe<Array<Maybe<PaymentMethodInstallmentOut>>>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodInstallmentOut = {
  __typename?: 'PaymentMethodInstallmentOut';
  installmentValue: Scalars['String']['output'];
  installments: Scalars['Int']['output'];
  observation: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['String']['output']>;
};

export type PaymentOut = {
  __typename?: 'PaymentOut';
  _fake?: Maybe<Scalars['String']['output']>;
};

export type Permissions = {
  __typename?: 'Permissions';
  impersonate?: Maybe<Scalars['Boolean']['output']>;
};

export type Power = {
  __typename?: 'Power';
  Float?: Maybe<Scalars['Float']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
  max_entry?: Maybe<Scalars['Float']['output']>;
  nominal?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PriceHistoryItem = {
  __typename?: 'PriceHistoryItem';
  information?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Price_History = {
  __typename?: 'Price_History';
  Void?: Maybe<Scalars['Void']['output']>;
  node_id: Scalars['String']['output'];
  node_name: Scalars['String']['output'];
  node_type: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Priority = {
  __typename?: 'Priority';
  Int?: Maybe<Scalars['Int']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Product = {
  __typename?: 'Product';
  associated_products?: Maybe<Array<Maybe<LinkProduct>>>;
  category: Category;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimension: Dimension;
  images: Array<Maybe<ImageModel>>;
  incompatible_products?: Maybe<Array<Maybe<LinkProduct>>>;
  info: Info;
  marketable: Scalars['Boolean']['output'];
  power: Power;
  price_raw?: Maybe<Scalars['Float']['output']>;
  price_to?: Maybe<Scalars['Float']['output']>;
  price_with_discount?: Maybe<Scalars['Float']['output']>;
  price_with_shipping_fee?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  surface: Surface;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Products = {
  __typename?: 'Products';
  JSON?: Maybe<Scalars['JSON']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type ProposalMetaOut = {
  __typename?: 'ProposalMetaOut';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type ProposalOut = {
  __typename?: 'ProposalOut';
  _fake?: Maybe<Scalars['String']['output']>;
};

export type ProposalStatusOut = {
  __typename?: 'ProposalStatusOut';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Qr_Code = {
  __typename?: 'Qr_Code';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Query = {
  __typename?: 'Query';
  downloadOrderDocument?: Maybe<DownloadOrderDocumentOut>;
  findUpsell: FindUpsellOut;
  /** Generate Insurance Csv */
  generate_insurance_csv_order_insurance_csv_get?: Maybe<HttpValidationError>;
  getAddress?: Maybe<GetAddressOut>;
  getAddressV2?: Maybe<GetAddressOut>;
  getAvailabilityAuditByCartId?: Maybe<AvailabilityAuditOut>;
  getAvailabilityAuditByProposalCode?: Maybe<AvailabilityAuditOut>;
  /** Get shopping cart by fintech id (financing id) */
  getCartByFintechId?: Maybe<GetCartByFintechId_Response>;
  getCartById?: Maybe<GetByIdOut>;
  getCartByPartner?: Maybe<GetByPartnerIdOut>;
  getCouponDetails?: Maybe<CouponDetailsOut>;
  getCustomCart?: Maybe<GetCustomCartOut>;
  getCustomKitOffers?: Maybe<GetCustomKitOffersOut>;
  getCustomKitOffersV2?: Maybe<GetCustomKitOffersV2Out>;
  getDeliveryTime?: Maybe<Shipping>;
  getDistributionCenter?: Maybe<DistributionCenter>;
  getEligibleFinancing?: Maybe<GetEligibleFinancingOut>;
  getFinancingDocumentsByBank?: Maybe<FinancingDocumentsByBankOut>;
  getFintechSimulation?: Maybe<FintechSimulationOut>;
  getInsuranceQuotation: Array<InsuranceQuotationOut>;
  getInvoiceInfo?: Maybe<GetInvoiceInfoOut>;
  getOpportunitiesSolfacilPlus?: Maybe<Opportunity>;
  getOrderDetails?: Maybe<GetOrderDetailsOut>;
  getOrderDetailsBackoffice?: Maybe<FindOrderOut>;
  /** Get Orders List */
  getOrdersList?: Maybe<GetOrdersList_Response>;
  getPartner: Partner;
  getPartners?: Maybe<GetPartnersOut>;
  getPaymentConditions?: Maybe<PaymentConditionsOut>;
  getPaymentInfo?: Maybe<GetPaymentInfoOut>;
  getPaymentLink?: Maybe<GetPaymentLinkOut>;
  getPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  getProposals?: Maybe<GetProposalsOut>;
  getScoreSolfacilPlus?: Maybe<Score>;
  getShippingOptionsByCart?: Maybe<Array<Maybe<GetShippingOptionOut>>>;
  getSpareProducts?: Maybe<GetSpareProductsOut>;
  getTriangulationPaymentMethods?: Maybe<Array<Maybe<PaymentCondition>>>;
  getUser: User;
  getUserFeatureFlags: GetUserFeatureFlagsOut;
  getUserTerms: UserTerms;
  getUsers?: Maybe<GetUsersOut>;
  /** Get Distribution Center By Id */
  get_distribution_center_by_id_v1_distribution_center__id__get?: Maybe<Get_Distribution_Center_By_Id_V1_Distribution_Center__Id__Get_Response>;
  /** Get Partner Volume */
  get_partner_volume_order_partner__document__volume_get?: Maybe<Get_Partner_Volume_Order_Partner__Document__Volume_Get_Response>;
  /** Get Shipping By Cd And Region */
  get_shipping_by_cd_and_region_v1_logistic_delivery_time_get?: Maybe<Get_Shipping_By_Cd_And_Region_V1_Logistic_Delivery_Time_Get_Response>;
  /** Healtcheck */
  healtcheck_healthcheck_get?: Maybe<Scalars['JSON']['output']>;
  isOrderManagementEnabled?: Maybe<Scalars['Boolean']['output']>;
  listCitiesByRegion: ListCitiesByRegionOut;
  listCoupons?: Maybe<ListCouponsOut>;
  listFinancingBanks?: Maybe<ListFinancingBanksOut>;
  listOrders?: Maybe<ListOrdersOut>;
  listOrdersBackoffice?: Maybe<ListOrdersBackofficeOut>;
  /** List Distribution Centers */
  list_distribution_centers_v1_distribution_center_get?: Maybe<List_Distribution_Centers_V1_Distribution_Center_Get_Response>;
  /** List Orders */
  list_orders_order__get?: Maybe<Array<Maybe<List_Orders_Order__Get_Response>>>;
  /** List Partner Orders */
  list_partner_orders_order_partner__document__get?: Maybe<Array<Maybe<List_Partner_Orders_Order_Partner__Document__Get_Response>>>;
  /** Prometheus metrics */
  metrics?: Maybe<ServiceStatus>;
  /** Metrics */
  metrics_metrics_get?: Maybe<Scalars['JSON']['output']>;
  searchCompatibleProducts?: Maybe<Array<Maybe<Product>>>;
  searchCompatibleProductsV2?: Maybe<SearchCompatibleProductsOut>;
  searchKit?: Maybe<SearchKitOut>;
  searchKitBySkuAndRegion?: Maybe<SearchKitBySkuAndRegionOut>;
  searchProductsAssembleKit?: Maybe<SearchProductsAssembleKitOut>;
};


export type QueryDownloadOrderDocumentArgs = {
  file_name?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['String']['input'];
};


export type QueryFindUpsellArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type QueryGenerate_Insurance_Csv_Order_Insurance_Csv_GetArgs = {
  channel: OrderChannel;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  page?: InputMaybe<Scalars['PositiveInt']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGetAddressArgs = {
  cep: Scalars['String']['input'];
  ibgeCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAddressV2Args = {
  cep: Scalars['String']['input'];
  ibgeCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAvailabilityAuditByCartIdArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type QueryGetAvailabilityAuditByProposalCodeArgs = {
  proposal_code: Scalars['Int']['input'];
};


export type QueryGetCartByFintechIdArgs = {
  fintech_id: Scalars['Int']['input'];
};


export type QueryGetCartByIdArgs = {
  cart_id: Scalars['UUID']['input'];
  summarized?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCartByPartnerArgs = {
  channel: Scalars['String']['input'];
  clear_payment?: InputMaybe<Scalars['Boolean']['input']>;
  clear_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  partner_id: Scalars['Int']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCouponDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCustomCartArgs = {
  channel: Scalars['String']['input'];
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomKitOffersArgs = {
  channel: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  inverter_manufacturer?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  inverter_type?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  structure_installation?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomKitOffersV2Args = {
  channel?: InputMaybe<Scalars['String']['input']>;
  dc_id?: InputMaybe<Scalars['Int']['input']>;
  inverter_manufacturer?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  inverter_type?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  structure_installation?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeliveryTimeArgs = {
  cd_id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
};


export type QueryGetDistributionCenterArgs = {
  cd_id: Scalars['Int']['input'];
};


export type QueryGetEligibleFinancingArgs = {
  page: Scalars['Int']['input'];
  partner_id: Scalars['Int']['input'];
  project_value: Scalars['Float']['input'];
  size: Scalars['Int']['input'];
  total_power: Scalars['Float']['input'];
};


export type QueryGetFinancingDocumentsByBankArgs = {
  bankCode: Scalars['String']['input'];
  personType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFintechSimulationArgs = {
  cart_id: Scalars['UUID']['input'];
  fintech_simulation_id: Scalars['UUID']['input'];
};


export type QueryGetInsuranceQuotationArgs = {
  cartId: Scalars['UUID']['input'];
};


export type QueryGetInvoiceInfoArgs = {
  cartId: Scalars['String']['input'];
};


export type QueryGetOpportunitiesSolfacilPlusArgs = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  purchaseValue?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetOrderDetailsArgs = {
  order_id: Scalars['String']['input'];
};


export type QueryGetOrderDetailsBackofficeArgs = {
  order_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrdersListArgs = {
  created_at?: InputMaybe<Scalars['JSON']['input']>;
  end_customer_name?: InputMaybe<Scalars['JSON']['input']>;
  order_flow_status?: InputMaybe<Scalars['JSON']['input']>;
  order_flow_type?: InputMaybe<Scalars['JSON']['input']>;
  order_number?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_ids?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetPartnerArgs = {
  partner_id: Scalars['Int']['input'];
};


export type QueryGetPartnersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPaymentConditionsArgs = {
  cart_id: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPaymentInfoArgs = {
  order_id: Scalars['String']['input'];
};


export type QueryGetPaymentLinkArgs = {
  order_id: Scalars['String']['input'];
};


export type QueryGetPaymentMethodsArgs = {
  cartId: Scalars['UUID']['input'];
};


export type QueryGetProposalsArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
  has_battery?: InputMaybe<Scalars['Boolean']['input']>;
  has_hybrid_inverter?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  responsible_id?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetScoreSolfacilPlusArgs = {
  partner_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetShippingOptionsByCartArgs = {
  cart_id: Scalars['UUID']['input'];
};


export type QueryGetSpareProductsArgs = {
  category: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  module_power?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  segmentation_id?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTriangulationPaymentMethodsArgs = {
  cartId: Scalars['UUID']['input'];
};


export type QueryGetUserTermsArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryGetUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  partial_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGet_Distribution_Center_By_Id_V1_Distribution_Center__Id__GetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGet_Partner_Volume_Order_Partner__Document__Volume_GetArgs = {
  document: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGet_Shipping_By_Cd_And_Region_V1_Logistic_Delivery_Time_GetArgs = {
  cd_id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
};


export type QueryListCitiesByRegionArgs = {
  capitalFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  region: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCouponsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListFinancingBanksArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOrdersArgs = {
  has_battery?: InputMaybe<Scalars['Boolean']['input']>;
  has_hybrid_inverter?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  payment_method?: InputMaybe<Scalars['String']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrdersBackofficeArgs = {
  has_battery?: InputMaybe<Scalars['Boolean']['input']>;
  has_hybrid_inverter?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  responsible_id?: InputMaybe<Scalars['Int']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryList_Distribution_Centers_V1_Distribution_Center_GetArgs = {
  ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryList_Orders_Order__GetArgs = {
  channel: OrderChannel;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  order_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  page?: InputMaybe<Scalars['PositiveInt']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatus>>>;
};


export type QueryList_Partner_Orders_Order_Partner__Document__GetArgs = {
  document: Scalars['String']['input'];
  page?: InputMaybe<Scalars['PositiveInt']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
};


export type QuerySearchCompatibleProductsArgs = {
  category: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  compatible_with_skus: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCompatibleProductsV2Args = {
  category: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  compatible_with_skus: Scalars['String']['input'];
  dc_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  module_power?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchKitArgs = {
  channel: Scalars['String']['input'];
  inverters_brand?: InputMaybe<Scalars['String']['input']>;
  inverters_electric_connection?: InputMaybe<Scalars['String']['input']>;
  inverters_power?: InputMaybe<Scalars['String']['input']>;
  modules_brand?: InputMaybe<Scalars['String']['input']>;
  modules_power?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  power?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort: Scalars['String']['input'];
  string_box?: InputMaybe<Scalars['String']['input']>;
  structure_installation?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchKitBySkuAndRegionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  dc_id: Scalars['Int']['input'];
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductsAssembleKitArgs = {
  inverter_manufacturer?: InputMaybe<Scalars['String']['input']>;
  inverter_nominal_power?: InputMaybe<Scalars['String']['input']>;
  inverter_type?: InputMaybe<Scalars['String']['input']>;
  network_type?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  structure_installation?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type Reason = {
  __typename?: 'Reason';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Recipient = {
  __typename?: 'Recipient';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type RecipientIn = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type Reference_Id = {
  __typename?: 'Reference_Id';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Region = {
  __typename?: 'Region';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type ReindexKitsOut = {
  __typename?: 'ReindexKitsOut';
  indexed_kits_count: Scalars['Int']['output'];
};

export type RemoveCouponCustomersInput = {
  cnpjs: Array<Scalars['String']['input']>;
};

export type RemoveCouponCustomersOut = {
  __typename?: 'RemoveCouponCustomersOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<UpdateCouponOutCustomer>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<UpdateCouponOutProduct>>;
  sales_channel?: Maybe<Array<UpdateCouponOutSalesChannel>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type RemoveCouponProductsInput = {
  products: Array<Scalars['String']['input']>;
};

export type RemoveCouponProductsOut = {
  __typename?: 'RemoveCouponProductsOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<RemoveCouponProductsOutCustomer>>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<RemoveCouponProductsOutProduct>>>;
  sales_channel?: Maybe<Array<Maybe<RemoveCouponProductsOutSalesChannel>>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type RemoveCouponProductsOutCustomer = {
  __typename?: 'RemoveCouponProductsOutCustomer';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cnpj: Scalars['String']['output'];
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type RemoveCouponProductsOutProduct = {
  __typename?: 'RemoveCouponProductsOutProduct';
  sku: Scalars['String']['output'];
};

export type RemoveCouponProductsOutSalesChannel = {
  __typename?: 'RemoveCouponProductsOutSalesChannel';
  name: Scalars['String']['output'];
};

export type RemoveFinancialTransferOut = {
  __typename?: 'RemoveFinancialTransferOut';
  id: Scalars['String']['output'];
};

export type RemoveInsuranceOut = {
  __typename?: 'RemoveInsuranceOut';
  assembled_kit?: Maybe<Scalars['Boolean']['output']>;
  available_at?: Maybe<Scalars['String']['output']>;
  category: CategoryOut;
  channel?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Mutation_RemoveInsuranceCart_OneOf_0_Coupon>;
  created_at: Scalars['DateTime']['output'];
  dc_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  has_insurance: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insurance_total: Scalars['Float']['output'];
  insurance_value: Scalars['Float']['output'];
  items: Array<Maybe<CartItemOut>>;
  order_id?: Maybe<Scalars['Int']['output']>;
  partner: PartnerOut;
  payment?: Maybe<Mutation_RemoveInsuranceCart_OneOf_0_Payment>;
  pre_sale: Scalars['Boolean']['output'];
  price_history?: Maybe<Price_History>;
  proposal?: Maybe<Mutation_RemoveInsuranceCart_OneOf_0_Proposal>;
  reference?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segmentation_id?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Mutation_RemoveInsuranceCart_OneOf_0_Shipping>;
  status: StatusOut;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  total_discount_inove: Scalars['Float']['output'];
  total_discount_solfacil_plus: Scalars['Float']['output'];
  type: TypeOut;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type RemoveInsuranceOut400 = {
  __typename?: 'RemoveInsuranceOut400';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveInsuranceOut403 = {
  __typename?: 'RemoveInsuranceOut403';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveInsuranceOut404 = {
  __typename?: 'RemoveInsuranceOut404';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveInsuranceOut409 = {
  __typename?: 'RemoveInsuranceOut409';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveProductOut400 = {
  __typename?: 'RemoveProductOut400';
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveProductOut403 = {
  __typename?: 'RemoveProductOut403';
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveProductOut404 = {
  __typename?: 'RemoveProductOut404';
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveTriangularTransactionOut = {
  __typename?: 'RemoveTriangularTransactionOut';
  id: Scalars['String']['output'];
};

export type Responsible = {
  __typename?: 'Responsible';
  id?: Maybe<Scalars['Int']['output']>;
  recipient?: Maybe<Recipient>;
};

export type SalesChannelInput = {
  name: Scalars['String']['input'];
};

export type Score = {
  __typename?: 'Score';
  current_score: Scalars['String']['output'];
  go_score: Scalars['String']['output'];
  has_risk: Scalars['Boolean']['output'];
  level: Scalars['String']['output'];
  next_transition_date: Scalars['String']['output'];
};

export type SearchCompatibleProductsMetaOut = {
  __typename?: 'SearchCompatibleProductsMetaOut';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type SearchCompatibleProductsOut = {
  __typename?: 'SearchCompatibleProductsOut';
  meta: SearchCompatibleProductsMetaOut;
  product_filters?: Maybe<Array<Maybe<ListProductOutputFacet>>>;
  products: Array<Maybe<Product>>;
};

export type SearchKitBySkuAndRegionOut = {
  __typename?: 'SearchKitBySkuAndRegionOut';
  available_at?: Maybe<Scalars['String']['output']>;
  big_numbers?: Maybe<Array<Maybe<BigNumber>>>;
  code: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  datasheets?: Maybe<Array<Maybe<Datasheet>>>;
  dc_id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  details?: Maybe<Array<Maybe<Detail>>>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  images: Array<Maybe<ImageModel>>;
  inverters?: Maybe<Array<Maybe<Inverter>>>;
  marketable: Scalars['Boolean']['output'];
  modules?: Maybe<Array<Maybe<Module>>>;
  payment_conditions?: Maybe<Array<Maybe<PaymentConditionOut>>>;
  power: Scalars['Float']['output'];
  pre_sale?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  price_from: Scalars['Float']['output'];
  price_raw: Scalars['Float']['output'];
  price_with_discount?: Maybe<Scalars['Float']['output']>;
  price_with_shipping_fee?: Maybe<Scalars['Float']['output']>;
  products: Array<Maybe<Product>>;
  region: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  solfacil_plus?: Maybe<SolfacilPlus>;
  structure?: Maybe<Structure>;
  updated_at: Scalars['String']['output'];
};

export type SearchKitBySkuOut = {
  __typename?: 'SearchKitBySkuOut';
  big_numbers?: Maybe<Array<Maybe<BigNumber>>>;
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  datasheets?: Maybe<Array<Maybe<Datasheet>>>;
  description: Scalars['String']['output'];
  details?: Maybe<Array<Maybe<Detail>>>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  inverters: Array<Maybe<Inverter>>;
  marketable: Scalars['Boolean']['output'];
  modules: Array<Maybe<Module>>;
  power: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  price_from?: Maybe<Scalars['Float']['output']>;
  price_raw?: Maybe<Scalars['Float']['output']>;
  seller: Seller;
  sku: Scalars['String']['output'];
  solfacil_plus?: Maybe<SolFacilPlus>;
  sorting_priority: Scalars['Int']['output'];
  structure: Structure;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type SearchKitOut = {
  __typename?: 'SearchKitOut';
  data: Array<Maybe<KitModel>>;
  facets: Array<Maybe<FacetOut>>;
  meta: Meta;
};

export type SearchKitsOut = {
  __typename?: 'SearchKitsOut';
  data?: Maybe<Array<Maybe<Kit>>>;
  facets?: Maybe<Array<Maybe<Facet>>>;
  meta?: Maybe<MetaOut>;
};

export type SearchProductAssembleKitOut = {
  __typename?: 'SearchProductAssembleKitOut';
  can_assemble_kit: Scalars['Boolean']['output'];
  facets: Array<Maybe<ListProductOutputFacet>>;
};

export type SearchProductBySkuAndRegionOut = {
  __typename?: 'SearchProductBySkuAndRegionOut';
  associated_products?: Maybe<Array<Maybe<LinkProduct>>>;
  category: Category;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  datasheet?: Maybe<Scalars['String']['output']>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimension: Dimension;
  images: Array<Maybe<ImageModel>>;
  incompatible_products?: Maybe<Array<Maybe<LinkProduct>>>;
  info: Info;
  marketable: Scalars['Boolean']['output'];
  power: Power;
  price_raw?: Maybe<Scalars['Float']['output']>;
  price_with_discount?: Maybe<Scalars['Float']['output']>;
  price_with_shipping_fee?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  surface: Surface;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SearchProductOut = {
  __typename?: 'SearchProductOut';
  data: Array<Maybe<Product>>;
  meta: Meta;
};

export type SearchProductsAssembleKitOut = {
  __typename?: 'SearchProductsAssembleKitOut';
  canAssembleKit?: Maybe<Scalars['Boolean']['output']>;
  dc_id?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<Array<Maybe<ListProductOutputFacet>>>;
  region?: Maybe<Scalars['String']['output']>;
};

export type SectionStatuses = {
  __typename?: 'SectionStatuses';
  concluded?: Maybe<Scalars['String']['output']>;
  formalization?: Maybe<Formalization>;
  installation?: Maybe<Scalars['String']['output']>;
  simulation?: Maybe<Scalars['String']['output']>;
};

export type Segmentation_Id = {
  __typename?: 'Segmentation_Id';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Seller = {
  __typename?: 'Seller';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Seller_Input = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  is_healthy?: Maybe<Scalars['Boolean']['output']>;
  service_name: Scalars['String']['output'];
  status?: Maybe<ServiceStatusEnum>;
};

export enum ServiceStatusEnum {
  Down = 'DOWN',
  Up = 'UP'
}

export type Shipping = {
  __typename?: 'Shipping';
  delivery_time: ShippingDeliveryTime;
  destination: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ShippingDeliveryTime = {
  __typename?: 'ShippingDeliveryTime';
  capital: ShippingTime;
  countryside: ShippingTime;
  dc_time: Scalars['Int']['output'];
};

export type ShippingOut = {
  __typename?: 'ShippingOut';
  type: Scalars['String']['output'];
};

export type ShippingTime = {
  __typename?: 'ShippingTime';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type SolFacilPlus = {
  __typename?: 'SolFacilPlus';
  discount_rate?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
};

export type SolFacilPlus_Input = {
  discount_rate?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
};

export type SolfacilPlus = {
  __typename?: 'SolfacilPlus';
  discount_rate?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
};

export type SolfacilPlusOut = {
  __typename?: 'SolfacilPlusOut';
  discount_rate: Scalars['Float']['output'];
  level: Scalars['Int']['output'];
};

export type State = {
  __typename?: 'State';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type State_Registration = {
  __typename?: 'State_Registration';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type StatusOut = {
  __typename?: 'StatusOut';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Street = {
  __typename?: 'Street';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Structure = {
  __typename?: 'Structure';
  datasheet?: Maybe<Scalars['String']['output']>;
  installation?: Maybe<Scalars['String']['output']>;
};

export type Structure_Input = {
  datasheet?: InputMaybe<Scalars['String']['input']>;
  installation?: InputMaybe<Scalars['String']['input']>;
};

export type Summary = {
  __typename?: 'Summary';
  body: SummaryBody;
};

export type SummaryBody = {
  __typename?: 'SummaryBody';
  items: Array<Maybe<SummaryItem>>;
};

export type SummaryItem = {
  __typename?: 'SummaryItem';
  information?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Surface = {
  __typename?: 'Surface';
  description?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Int']['output']>;
};

export type TriangularTransactionIn = {
  invoice_issue_date: Scalars['String']['input'];
  invoice_number: Scalars['String']['input'];
  invoice_serial_number: Scalars['String']['input'];
};

export type TypeOut = {
  __typename?: 'TypeOut';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UpdateCouponCustomerInput = {
  available_quantity: Scalars['Int']['input'];
};

export type UpdateCouponCustomerOut = {
  __typename?: 'UpdateCouponCustomerOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<UpdateCouponCustomerOutCustomer>>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<UpdateCouponCustomerOutProduct>>>;
  sales_channel?: Maybe<Array<Maybe<UpdateCouponCustomerOutSalesChannel>>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type UpdateCouponCustomerOutCustomer = {
  __typename?: 'UpdateCouponCustomerOutCustomer';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cnpj: Scalars['String']['output'];
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type UpdateCouponCustomerOutProduct = {
  __typename?: 'UpdateCouponCustomerOutProduct';
  sku: Scalars['String']['output'];
};

export type UpdateCouponCustomerOutSalesChannel = {
  __typename?: 'UpdateCouponCustomerOutSalesChannel';
  name: Scalars['String']['output'];
};

export type UpdateCouponInput = {
  available_quantity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expires_in?: InputMaybe<Scalars['String']['input']>;
  min_purchase_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCouponOut = {
  __typename?: 'UpdateCouponOut';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<UpdateCouponOutCustomer>>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['String']['output'];
  id: Scalars['String']['output'];
  min_purchase_amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<UpdateCouponOutProduct>>;
  sales_channel?: Maybe<Array<UpdateCouponOutSalesChannel>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  used_quantity?: Maybe<Scalars['Int']['output']>;
};

export type UpdateCouponOutCustomer = {
  __typename?: 'UpdateCouponOutCustomer';
  available_quantity: Scalars['Int']['output'];
  cnpj: Scalars['String']['output'];
};

export type UpdateCouponOutProduct = {
  __typename?: 'UpdateCouponOutProduct';
  sku: Scalars['String']['output'];
};

export type UpdateCouponOutSalesChannel = {
  __typename?: 'UpdateCouponOutSalesChannel';
  name: Scalars['String']['output'];
};

export type UpdateOrderFlowIn_Input = {
  reason: Scalars['String']['input'];
  status: OrderFlowStatusEnum;
};

export type UpdateOrderFlowOut = {
  __typename?: 'UpdateOrderFlowOut';
  flow_type: OrderFlowTypeEnum;
  order_id: Scalars['UUID']['output'];
  status: OrderFlowStatusDto;
};

export type UpdateOrderStatusIn_Input = {
  reason?: InputMaybe<Scalars['JSON']['input']>;
  status: OrderStatusEnum;
};

export type Updated_At = {
  __typename?: 'Updated_At';
  DateTime?: Maybe<Scalars['DateTime']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  partner?: Maybe<Partner>;
  permissions?: Maybe<Permissions>;
  profile?: Maybe<Scalars['String']['output']>;
};

export type UserTerms = {
  __typename?: 'UserTerms';
  operating_agreement: OperatingAgreement;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  loc: Array<Maybe<Query_Generate_Insurance_Csv_Order_Insurance_Csv_Get_Detail_Items_Loc_Items>>;
  msg: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Void_Container = {
  __typename?: 'Void_container';
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Wholesale = {
  __typename?: 'Wholesale';
  status: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export type Zip_Code = {
  __typename?: 'Zip_Code';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type AddCouponCart_Response = AddCouponOut | AddCouponOut400 | AddCouponOut403 | AddCouponOut404 | AddCouponOut409;

export type AddDiscountCart_Response = AddDiscountOut | AddDiscountOut400 | AddDiscountOut403 | AddDiscountOut404 | AddDiscountOut409;

export type AddInsuranceCart_Response = AddInsuranceOut | AddInsuranceOut400 | AddInsuranceOut403 | AddInsuranceOut404 | AddInsuranceOut409;

export type AddProductCart_Response = AddProductOut | AddProductOut400 | AddProductOut403 | AddProductOut404 | AddProductOut409 | AddProductOut_Input2;

export type AddProductCustomCart_Response = AddProductCustomCartOut | AddProductCustomCartOut400 | AddProductCustomCartOut403 | AddProductCustomCartOut404 | AddProductCustomCartOut409 | AddProductCustomCartOut_Input2;

export type AdjustCart_Response = AdjustCartOut | AdjustCartOut400 | AdjustCartOut403 | AdjustCartOut404 | AdjustCartOut409;

export type AdjustItemCart_Response = AdjustItemOut | AdjustItemOut400 | AdjustItemOut403 | AdjustItemOut404 | AdjustItemOut409 | AdjustItemOut_Input2;

export type ClearCart_Response = ClearOut | ClearOut404;

export type CompleteCustomCart_Response = CompleteCustomCartOut | CompleteCustomCartOut400 | CompleteCustomCartOut403 | CompleteCustomCartOut404 | CompleteCustomCartOut409;

export type CreateCustomCart_Response = CreateCustomCartOut | CreateCustomCartOut400 | CreateCustomCartOut403 | CreateCustomCartOut404 | CreateCustomCartOut409 | CreateCustomCartOut_Input2;

export type CreateOrderFlow_Response = CreateOrderFlowOut | HttpValidationError;

export type CreateOrder_Response = CreateOrderOut | HttpValidationError;

export type FillPaymentCart_Response = FillPaymentOut400 | FillPaymentOut403 | FillPaymentOut404 | FillPaymentOut_Input | FillPaymentOut_Output;

export type FillShippingCart_Response = FillShippingOut | FillShippingOut400 | FillShippingOut403 | FillShippingOut404 | FillShippingOut_Input2;

export type GetCartByFintechId_Response = GetByFintechIdOut | GetByFintechIdOut404;

export type GetCartById_Response = GetByIdOut | GetByIdOut404;

export type GetCartByPartner_Response = GetByPartnerIdOut | GetByPartnerIdOut404;

export type GetCustomCart_Response = GetCustomCartOut | GetCustomCartOut404;

export type GetOrdersList_Response = GetOrdersListOut | HttpValidationError;

export type Get_Distribution_Center_By_Id_V1_Distribution_Center__Id__Get_Response = DistributionCenter | HttpValidationError;

export type Get_Partner_Volume_Order_Partner__Document__Volume_Get_Response = HttpValidationError | OrderPartnerVolume;

export type Get_Shipping_By_Cd_And_Region_V1_Logistic_Delivery_Time_Get_Response = HttpValidationError | Shipping;

export type IndexKits_Response = HttpValidationError | IndexKitsOut;

export type List_Distribution_Centers_V1_Distribution_Center_Get_Response = DistributionCenterShippingList | HttpValidationError;

export type List_Orders_Order__Get_Response = HttpValidationError | Order;

export type List_Partner_Orders_Order_Partner__Document__Get_Response = HttpValidationError | Order;

export type Mutation_AddCouponCart_OneOf_0_Coupon = {
  __typename?: 'mutation_addCouponCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddCouponCart_OneOf_0_Payment = {
  __typename?: 'mutation_addCouponCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddCouponCart_OneOf_0_Proposal = {
  __typename?: 'mutation_addCouponCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddCouponCart_OneOf_0_Shipping = {
  __typename?: 'mutation_addCouponCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address = {
  __typename?: 'mutation_addCouponCart_oneOf_0_shipping_anyOf_0_address';
  Void?: Maybe<Scalars['Void']['output']>;
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  district: Scalars['String']['output'];
  ibgecode?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast = {
  __typename?: 'mutation_addCouponCart_oneOf_0_shipping_anyOf_0_forecast';
  Void?: Maybe<Scalars['Void']['output']>;
  dc_time: Scalars['Int']['output'];
  delivery_time: DeliveryForecastOut;
};

export type Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient = {
  __typename?: 'mutation_addCouponCart_oneOf_0_shipping_anyOf_0_recipient';
  Void?: Maybe<Scalars['Void']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type Mutation_AddDiscountCart_OneOf_0_Coupon = {
  __typename?: 'mutation_addDiscountCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddDiscountCart_OneOf_0_Payment = {
  __typename?: 'mutation_addDiscountCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddDiscountCart_OneOf_0_Proposal = {
  __typename?: 'mutation_addDiscountCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddDiscountCart_OneOf_0_Shipping = {
  __typename?: 'mutation_addDiscountCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddInsuranceCart_OneOf_0_Coupon = {
  __typename?: 'mutation_addInsuranceCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddInsuranceCart_OneOf_0_Payment = {
  __typename?: 'mutation_addInsuranceCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddInsuranceCart_OneOf_0_Proposal = {
  __typename?: 'mutation_addInsuranceCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddInsuranceCart_OneOf_0_Shipping = {
  __typename?: 'mutation_addInsuranceCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddProductCart_OneOf_0_Coupon = {
  __typename?: 'mutation_addProductCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddProductCart_OneOf_0_Payment = {
  __typename?: 'mutation_addProductCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddProductCart_OneOf_0_Proposal = {
  __typename?: 'mutation_addProductCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddProductCart_OneOf_0_Shipping = {
  __typename?: 'mutation_addProductCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddProductCart_OneOf_1_Coupon = {
  __typename?: 'mutation_addProductCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddProductCart_OneOf_1_Payment = {
  __typename?: 'mutation_addProductCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddProductCart_OneOf_1_Proposal = {
  __typename?: 'mutation_addProductCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddProductCart_OneOf_1_Shipping = {
  __typename?: 'mutation_addProductCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_0_Coupon = {
  __typename?: 'mutation_addProductCustomCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_0_Payment = {
  __typename?: 'mutation_addProductCustomCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddProductCustomCart_OneOf_0_Proposal = {
  __typename?: 'mutation_addProductCustomCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddProductCustomCart_OneOf_0_Shipping = {
  __typename?: 'mutation_addProductCustomCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_1_Coupon = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_1_Payment = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddProductCustomCart_OneOf_1_Proposal = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddProductCustomCart_OneOf_1_Shipping = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_shipping_anyOf_0_address';
  Void?: Maybe<Scalars['Void']['output']>;
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  district: Scalars['String']['output'];
  ibgecode?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_shipping_anyOf_0_forecast';
  Void?: Maybe<Scalars['Void']['output']>;
  dc_time: Scalars['Int']['output'];
  delivery_time: DeliveryForecastOut;
};

export type Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient = {
  __typename?: 'mutation_addProductCustomCart_oneOf_1_shipping_anyOf_0_recipient';
  Void?: Maybe<Scalars['Void']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type Mutation_AddProductsCustomCart_Coupon = {
  __typename?: 'mutation_addProductsCustomCart_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AddProductsCustomCart_Payment = {
  __typename?: 'mutation_addProductsCustomCart_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AddProductsCustomCart_Proposal = {
  __typename?: 'mutation_addProductsCustomCart_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AddProductsCustomCart_Shipping = {
  __typename?: 'mutation_addProductsCustomCart_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AdjustCart_OneOf_0_Coupon = {
  __typename?: 'mutation_adjustCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AdjustCart_OneOf_0_Payment = {
  __typename?: 'mutation_adjustCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AdjustCart_OneOf_0_Proposal = {
  __typename?: 'mutation_adjustCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AdjustCart_OneOf_0_Shipping = {
  __typename?: 'mutation_adjustCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AdjustItemCart_OneOf_0_Coupon = {
  __typename?: 'mutation_adjustItemCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AdjustItemCart_OneOf_0_Payment = {
  __typename?: 'mutation_adjustItemCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AdjustItemCart_OneOf_0_Proposal = {
  __typename?: 'mutation_adjustItemCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AdjustItemCart_OneOf_0_Shipping = {
  __typename?: 'mutation_adjustItemCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_AdjustItemCart_OneOf_1_Coupon = {
  __typename?: 'mutation_adjustItemCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_AdjustItemCart_OneOf_1_Payment = {
  __typename?: 'mutation_adjustItemCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_AdjustItemCart_OneOf_1_Proposal = {
  __typename?: 'mutation_adjustItemCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_AdjustItemCart_OneOf_1_Shipping = {
  __typename?: 'mutation_adjustItemCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_CompleteCustomCart_OneOf_0_Coupon = {
  __typename?: 'mutation_completeCustomCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_CompleteCustomCart_OneOf_0_Payment = {
  __typename?: 'mutation_completeCustomCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_CompleteCustomCart_OneOf_0_Proposal = {
  __typename?: 'mutation_completeCustomCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_CompleteCustomCart_OneOf_0_Shipping = {
  __typename?: 'mutation_completeCustomCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_ConvertToProposal_Coupon = {
  __typename?: 'mutation_convertToProposal_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_ConvertToProposal_Payment = {
  __typename?: 'mutation_convertToProposal_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_ConvertToProposal_Proposal = {
  __typename?: 'mutation_convertToProposal_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_ConvertToProposal_Shipping = {
  __typename?: 'mutation_convertToProposal_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_CreateCustomCart_OneOf_0_Coupon = {
  __typename?: 'mutation_createCustomCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_CreateCustomCart_OneOf_0_Payment = {
  __typename?: 'mutation_createCustomCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_CreateCustomCart_OneOf_0_Proposal = {
  __typename?: 'mutation_createCustomCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_CreateCustomCart_OneOf_0_Shipping = {
  __typename?: 'mutation_createCustomCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_CreateCustomCart_OneOf_1_Coupon = {
  __typename?: 'mutation_createCustomCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_CreateCustomCart_OneOf_1_Payment = {
  __typename?: 'mutation_createCustomCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_CreateCustomCart_OneOf_1_Proposal = {
  __typename?: 'mutation_createCustomCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_CreateCustomCart_OneOf_1_Shipping = {
  __typename?: 'mutation_createCustomCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_CreateOrderFlow_OneOf_0_Payment = {
  __typename?: 'mutation_createOrderFlow_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  expiration_date: Scalars['DateTime']['output'];
  link: Scalars['String']['output'];
  method: OrderPaymentTypeEnum;
  qr_code: Qr_Code;
};

export type Mutation_CreateOrder_OneOf_0_Comments = {
  __typename?: 'mutation_createOrder_oneOf_0_comments';
  Void?: Maybe<Scalars['Void']['output']>;
  internal?: Maybe<Internal>;
  invoice?: Maybe<Invoice>;
};

export type Mutation_CreateOrder_OneOf_0_Erp = {
  __typename?: 'mutation_createOrder_oneOf_0_erp';
  Void?: Maybe<Scalars['Void']['output']>;
  branch?: Maybe<Branch>;
  id?: Maybe<Mutation_CreateOrder_OneOf_0_Erp_AnyOf_0_Id>;
};

export type Mutation_CreateOrder_OneOf_0_Erp_AnyOf_0_Id = {
  __typename?: 'mutation_createOrder_oneOf_0_erp_anyOf_0_id';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Mutation_FillPaymentCart_OneOf_0_Coupon = {
  __typename?: 'mutation_fillPaymentCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_FillPaymentCart_OneOf_0_Payment = {
  __typename?: 'mutation_fillPaymentCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_FillPaymentCart_OneOf_0_Proposal = {
  __typename?: 'mutation_fillPaymentCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_FillPaymentCart_OneOf_0_Shipping = {
  __typename?: 'mutation_fillPaymentCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_FillPaymentCart_OneOf_1_Coupon = {
  __typename?: 'mutation_fillPaymentCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_FillPaymentCart_OneOf_1_Payment = {
  __typename?: 'mutation_fillPaymentCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_FillPaymentCart_OneOf_1_Proposal = {
  __typename?: 'mutation_fillPaymentCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_FillPaymentCart_OneOf_1_Shipping = {
  __typename?: 'mutation_fillPaymentCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_FillShippingCart_OneOf_0_Coupon = {
  __typename?: 'mutation_fillShippingCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_FillShippingCart_OneOf_0_Payment = {
  __typename?: 'mutation_fillShippingCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_FillShippingCart_OneOf_0_Proposal = {
  __typename?: 'mutation_fillShippingCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_FillShippingCart_OneOf_0_Shipping = {
  __typename?: 'mutation_fillShippingCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_FillShippingCart_OneOf_1_Coupon = {
  __typename?: 'mutation_fillShippingCart_oneOf_1_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_FillShippingCart_OneOf_1_Payment = {
  __typename?: 'mutation_fillShippingCart_oneOf_1_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_FillShippingCart_OneOf_1_Proposal = {
  __typename?: 'mutation_fillShippingCart_oneOf_1_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_FillShippingCart_OneOf_1_Shipping = {
  __typename?: 'mutation_fillShippingCart_oneOf_1_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Forecast>;
  recipient?: Maybe<Mutation_AddProductCustomCart_OneOf_1_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Mutation_RemoveInsuranceCart_OneOf_0_Coupon = {
  __typename?: 'mutation_removeInsuranceCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation_RemoveInsuranceCart_OneOf_0_Payment = {
  __typename?: 'mutation_removeInsuranceCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Mutation_RemoveInsuranceCart_OneOf_0_Proposal = {
  __typename?: 'mutation_removeInsuranceCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Mutation_RemoveInsuranceCart_OneOf_0_Shipping = {
  __typename?: 'mutation_removeInsuranceCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_Generate_Insurance_Csv_Order_Insurance_Csv_Get_Detail_Items_Loc_Items = {
  __typename?: 'query_generate_insurance_csv_order_insurance_csv_get_detail_items_loc_items';
  Int?: Maybe<Scalars['Int']['output']>;
  String?: Maybe<Scalars['String']['output']>;
};

export type Query_GetCartByFintechId_OneOf_0_Coupon = {
  __typename?: 'query_getCartByFintechId_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query_GetCartByFintechId_OneOf_0_Payment = {
  __typename?: 'query_getCartByFintechId_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Query_GetCartByFintechId_OneOf_0_Proposal = {
  __typename?: 'query_getCartByFintechId_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Query_GetCartByFintechId_OneOf_0_Shipping = {
  __typename?: 'query_getCartByFintechId_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_GetCartById_OneOf_0_Coupon = {
  __typename?: 'query_getCartById_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query_GetCartById_OneOf_0_Payment = {
  __typename?: 'query_getCartById_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Query_GetCartById_OneOf_0_Proposal = {
  __typename?: 'query_getCartById_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Query_GetCartById_OneOf_0_Shipping = {
  __typename?: 'query_getCartById_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_GetCartByPartner_OneOf_0_Buyer = {
  __typename?: 'query_getCartByPartner_oneOf_0_buyer';
  Void?: Maybe<Scalars['Void']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  document_number: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state_registration?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Query_GetCartByPartner_OneOf_0_Coupon = {
  __typename?: 'query_getCartByPartner_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query_GetCartByPartner_OneOf_0_Payment = {
  __typename?: 'query_getCartByPartner_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Query_GetCartByPartner_OneOf_0_Proposal = {
  __typename?: 'query_getCartByPartner_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Query_GetCartByPartner_OneOf_0_Shipping = {
  __typename?: 'query_getCartByPartner_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_GetCustomCart_OneOf_0_Coupon = {
  __typename?: 'query_getCustomCart_oneOf_0_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query_GetCustomCart_OneOf_0_Payment = {
  __typename?: 'query_getCustomCart_oneOf_0_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Query_GetCustomCart_OneOf_0_Proposal = {
  __typename?: 'query_getCustomCart_oneOf_0_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Query_GetCustomCart_OneOf_0_Shipping = {
  __typename?: 'query_getCustomCart_oneOf_0_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_GetProposals_Proposals_Items_Coupon = {
  __typename?: 'query_getProposals_proposals_items_coupon';
  Void?: Maybe<Scalars['Void']['output']>;
  discount: DiscountOut;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query_GetProposals_Proposals_Items_Payment = {
  __typename?: 'query_getProposals_proposals_items_payment';
  Void?: Maybe<Scalars['Void']['output']>;
  billing?: Maybe<BillingOut>;
  buyer?: Maybe<BuyerOut>;
  fintech_id?: Maybe<Scalars['Int']['output']>;
  installment_count?: Maybe<Scalars['Int']['output']>;
  method: MethodOut;
};

export type Query_GetProposals_Proposals_Items_Proposal = {
  __typename?: 'query_getProposals_proposals_items_proposal';
  Void?: Maybe<Scalars['Void']['output']>;
  code: Scalars['Int']['output'];
  status: ProposalStatusOut;
};

export type Query_GetProposals_Proposals_Items_Shipping = {
  __typename?: 'query_getProposals_proposals_items_shipping';
  Void?: Maybe<Scalars['Void']['output']>;
  address?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Address>;
  delivery_rural_area?: Maybe<Scalars['Boolean']['output']>;
  forecast?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Forecast>;
  price?: Maybe<Scalars['Float']['output']>;
  recipient?: Maybe<Mutation_AddCouponCart_OneOf_0_Shipping_AnyOf_0_Recipient>;
  type: Scalars['String']['output'];
};

export type Query_Get_Shipping_By_Cd_And_Region_V1_Logistic_Delivery_Time_Get_OneOf_1_Detail_Items_Loc_Items = {
  __typename?: 'query_get_shipping_by_cd_and_region_v1_logistic_delivery_time_get_oneOf_1_detail_items_loc_items';
  Int?: Maybe<Scalars['Int']['output']>;
  String?: Maybe<Scalars['String']['output']>;
};

export type Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Address = {
  __typename?: 'query_list_partner_orders_order_partner__document__get_oneOf_0_items_address';
  Void?: Maybe<Scalars['Void']['output']>;
  city: Scalars['String']['output'];
  district: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Customer = {
  __typename?: 'query_list_partner_orders_order_partner__document__get_oneOf_0_items_customer';
  Void?: Maybe<Scalars['Void']['output']>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Items = {
  __typename?: 'query_list_partner_orders_order_partner__document__get_oneOf_0_items_items';
  Void?: Maybe<Scalars['Void']['output']>;
  insurance?: Maybe<Insurance>;
  inversor?: Maybe<Inversor>;
  module?: Maybe<Module>;
};

export type Query_List_Partner_Orders_Order_Partner__Document__Get_OneOf_0_Items_Partner = {
  __typename?: 'query_list_partner_orders_order_partner__document__get_oneOf_0_items_partner';
  Void?: Maybe<Scalars['Void']['output']>;
  corporate_name: Scalars['String']['output'];
  document: Scalars['String']['output'];
  trade_name: Scalars['String']['output'];
};

export type Query_SearchProducts_OneOf_1_Detail_Items_Loc_Items = {
  __typename?: 'query_searchProducts_oneOf_1_detail_items_loc_items';
  Int?: Maybe<Scalars['Int']['output']>;
  String?: Maybe<Scalars['String']['output']>;
};

export type RemoveInsuranceCart_Response = RemoveInsuranceOut | RemoveInsuranceOut400 | RemoveInsuranceOut403 | RemoveInsuranceOut404 | RemoveInsuranceOut409;

export type RemoveProductCart_Response = RemoveProductOut400 | RemoveProductOut403 | RemoveProductOut404 | Void_Container;

export type SearchKitBySkuAndRegion_Response = HttpValidationError | SearchKitBySkuAndRegionOut;

export type SearchKitBySku_Response = HttpValidationError | SearchKitBySkuOut;

export type SearchKit_Response = HttpValidationError | SearchKitOut;

export type SearchKits_Response = HttpValidationError | SearchKitsOut;

export type SearchProductBySkuAndRegion_Response = HttpValidationError | SearchProductBySkuAndRegionOut;

export type SearchProductsAssembleKit_Response = HttpValidationError | SearchProductAssembleKitOut;

export type SearchProducts_Response = HttpValidationError | SearchProductOut;

export type UpdateOrderFlowStatus_Response = HttpValidationError | UpdateOrderFlowOut;

export type UpdateOrderStatus_Response = HttpValidationError | Void_Container;

export type GetAvailabilityAuditByCartIdQueryVariables = Exact<{
  cart_id: Scalars['UUID']['input'];
}>;


export type GetAvailabilityAuditByCartIdQuery = { __typename?: 'Query', getAvailabilityAuditByCartId?: { __typename?: 'AvailabilityAuditOut', overall_status: string, cart_id: string, distribution_center_id?: number | null, region?: string | null, items: Array<{ __typename?: 'AuditItemOut', sku: string, amount: number, status: string, reasons: Array<string>, product?: { __typename?: 'AuditProductInfo', name?: string | null, image_url?: string | null } | null, stock?: { __typename?: 'AuditStockInfo', status?: string | null, current?: number | null, future?: number | null, reserved?: number | null } | null, checks?: { __typename?: 'AuditChecksInfo', exists?: boolean | null, deleted?: boolean | null, has_product_info?: boolean | null, has_cost?: boolean | null, has_price_for_region?: boolean | null } | null }> } | null };

export type GetAvailabilityAuditByProposalCodeQueryVariables = Exact<{
  proposal_code: Scalars['Int']['input'];
}>;


export type GetAvailabilityAuditByProposalCodeQuery = { __typename?: 'Query', getAvailabilityAuditByProposalCode?: { __typename?: 'AvailabilityAuditOut', overall_status: string, cart_id: string, distribution_center_id?: number | null, region?: string | null, items: Array<{ __typename?: 'AuditItemOut', sku: string, amount: number, status: string, reasons: Array<string>, product?: { __typename?: 'AuditProductInfo', name?: string | null, image_url?: string | null } | null, stock?: { __typename?: 'AuditStockInfo', status?: string | null, current?: number | null, future?: number | null, reserved?: number | null } | null, checks?: { __typename?: 'AuditChecksInfo', exists?: boolean | null, deleted?: boolean | null, has_product_info?: boolean | null, has_cost?: boolean | null, has_price_for_region?: boolean | null } | null }> } | null };

export type AdjustCartMutationVariables = Exact<{
  cart_id: Scalars['UUID']['input'];
  input: AdjustCartInRoute_Input;
}>;


export type AdjustCartMutation = { __typename?: 'Mutation', adjustCart?: { __typename?: 'AdjustCartOut', id: string, segmentation_id?: string | null, channel?: string | null, category: { __typename?: 'CategoryOut', id: number, description: string }, status: { __typename?: 'StatusOut', id: number, description: string }, proposal?: { __typename?: 'mutation_adjustCart_oneOf_0_proposal', code: number } | null, partner: { __typename?: 'PartnerOut', id: number, cnpj?: string | null } } | null };

export type AddCouponCustomersMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: AddCouponCustomersInput;
}>;


export type AddCouponCustomersMutation = { __typename?: 'Mutation', addCouponCustomers?: { __typename?: 'AddCouponCustomersOut', id: string, name: string, status: string, customers?: Array<{ __typename?: 'AddCouponCustomersOutCustomer', cnpj: string, available_quantity?: number | null, used_quantity?: number | null } | null> | null } | null };

export type AddCouponProductsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: AddCouponProductsInput;
}>;


export type AddCouponProductsMutation = { __typename?: 'Mutation', addCouponProducts?: { __typename?: 'AddCouponProductsOut', id: string, name: string, status: string, discount_rate?: number | null, discount_amount?: number | null, min_purchase_amount?: number | null, available_quantity?: number | null, used_quantity?: number | null, created_by?: string | null, updated_by?: string | null, deleted_by?: string | null, expires_in: string, created_at: string, updated_at?: string | null, deleted_at?: string | null, sales_channel?: Array<{ __typename?: 'AddCouponProductsOutSalesChannel', name: string } | null> | null, customers?: Array<{ __typename?: 'AddCouponProductsOutCustomer', cnpj: string, available_quantity?: number | null, used_quantity?: number | null } | null> | null, products?: Array<{ __typename?: 'AddCouponProductsOutProduct', sku: string } | null> | null } | null };

export type CreateCouponMutationVariables = Exact<{
  input: CreateCouponInput;
}>;


export type CreateCouponMutation = { __typename?: 'Mutation', createCoupon?: { __typename?: 'CreateCouponOut', id: string, name: string, status: string, created_at: string, expires_in: string, discount_rate?: number | null, description?: string | null, discount_amount?: number | null, min_purchase_amount?: number | null, available_quantity?: number | null, used_quantity?: number | null, sales_channel?: Array<{ __typename?: 'CreateCouponOutSalesChannel', name: string }> | null, customers?: Array<{ __typename?: 'CreateCouponOutCustomer', cnpj: string, available_quantity: number }> | null, products?: Array<{ __typename?: 'CreateCouponOutProduct', sku: string }> | null } | null };

export type DeactivateCouponMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeactivateCouponMutation = { __typename?: 'Mutation', deactivateCoupon?: string | null };

export type GetCouponDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCouponDetailsQuery = { __typename?: 'Query', getCouponDetails?: { __typename?: 'CouponDetailsOut', id: string, name: string, status: string, created_at: string, expires_in: string, discount_rate?: number | null, discount_amount?: number | null, min_purchase_amount?: number | null, available_quantity?: number | null, used_quantity?: number | null, description?: string | null, created_by?: string | null, updated_at?: string | null, updated_by?: string | null, sales_channel?: Array<{ __typename?: 'CouponDetailsOutSalesChannel', name: string } | null> | null, customers?: Array<{ __typename?: 'CouponDetailsOutCustomer', cnpj: string, available_quantity?: number | null, used_quantity?: number | null } | null> | null, products?: Array<{ __typename?: 'CouponDetailsOutProduct', sku: string } | null> | null } | null };

export type ListCouponsQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListCouponsQuery = { __typename?: 'Query', listCoupons?: { __typename?: 'ListCouponsOut', data: Array<{ __typename?: 'ListCouponsOutData', id: string, name: string, discount_amount?: number | null, discount_rate?: number | null, status: string, created_at: string, expires_in: string, deleted_at?: string | null } | null>, meta: { __typename?: 'ListCouponsOutMeta', page: number, size: number, count: number } } | null };

export type RemoveCouponCustomersMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: RemoveCouponCustomersInput;
}>;


export type RemoveCouponCustomersMutation = { __typename?: 'Mutation', removeCouponCustomers?: { __typename?: 'RemoveCouponCustomersOut', id: string, name: string, status: string, customers?: Array<{ __typename?: 'UpdateCouponOutCustomer', cnpj: string, available_quantity: number }> | null } | null };

export type RemoveCouponProductsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: RemoveCouponProductsInput;
}>;


export type RemoveCouponProductsMutation = { __typename?: 'Mutation', removeCouponProducts?: { __typename?: 'RemoveCouponProductsOut', id: string, name: string, status: string, products?: Array<{ __typename?: 'RemoveCouponProductsOutProduct', sku: string } | null> | null } | null };

export type UpdateCouponMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: UpdateCouponInput;
}>;


export type UpdateCouponMutation = { __typename?: 'Mutation', updateCoupon?: { __typename?: 'UpdateCouponOut', id: string, name: string, status: string, discount_rate?: number | null, discount_amount?: number | null, min_purchase_amount?: number | null, available_quantity?: number | null, used_quantity?: number | null, expires_in: string, description?: string | null, created_at: string, updated_at?: string | null } | null };

export type UpdateCouponCustomerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  cnpj: Scalars['String']['input'];
  input: UpdateCouponCustomerInput;
}>;


export type UpdateCouponCustomerMutation = { __typename?: 'Mutation', updateCouponCustomer?: { __typename?: 'UpdateCouponCustomerOut', id: string, name: string, status: string, discount_rate?: number | null, discount_amount?: number | null, min_purchase_amount?: number | null, available_quantity?: number | null, used_quantity?: number | null, expires_in: string, description?: string | null, created_at: string, updated_at?: string | null } | null };

export type CancelOrderMutationVariables = Exact<{
  order_id: Scalars['String']['input'];
  cancelation_reason: Scalars['String']['input'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: { __typename: 'CancelOrderOut', order_id: string, status?: string | null } | null };

export type CreateOrderDeliveryInvoicesMutationVariables = Exact<{
  order_id: Scalars['String']['input'];
}>;


export type CreateOrderDeliveryInvoicesMutation = { __typename?: 'Mutation', createOrderDeliveryInvoices?: { __typename?: 'CreateOrderInvoiceOut', invoices: Array<{ __typename?: 'CreateOrderInvoiceItem', url: string }> } | null };

export type CreateOrderInvoiceMutationVariables = Exact<{
  order_id: Scalars['String']['input'];
  delivery_id?: InputMaybe<Scalars['String']['input']>;
  only_base_invoice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrderInvoiceMutation = { __typename?: 'Mutation', createOrderInvoice?: { __typename?: 'CreateOrderInvoiceOut', invoices: Array<{ __typename?: 'CreateOrderInvoiceItem', url: string }> } | null };

export type CreateOrderMirrorByIdMutationVariables = Exact<{
  order_id: Scalars['String']['input'];
}>;


export type CreateOrderMirrorByIdMutation = { __typename?: 'Mutation', createOrderMirrorById?: { __typename?: 'CreateOrderMirrorByIdOut', url?: string | null } | null };

export type DownloadOrderDocumentQueryVariables = Exact<{
  order_id: Scalars['String']['input'];
  file_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadOrderDocumentQuery = { __typename?: 'Query', downloadOrderDocument?: { __typename?: 'DownloadOrderDocumentOut', url?: string | null, expires_at?: string | null } | null };

export type GetOrderDetailsBackofficeQueryVariables = Exact<{
  order_id: Scalars['String']['input'];
}>;


export type GetOrderDetailsBackofficeQuery = { __typename?: 'Query', getOrderDetailsBackoffice?: { __typename?: 'FindOrderOut', id: string, number: number, type: string, innova_id?: number | null, client_name: string, payment_method: string, available_at?: string | null, deliveries_title: string, pending_payment: boolean, partially_invoiced: boolean, pre_sale: boolean, available_at_date?: string | null, delivery_estimate?: string | null, schedule_pickup_text?: string | null, documents: Array<string | null>, tracking_link?: string | null, invoice_info: { __typename?: 'OrderInvoiceInfo', customer_document: string, customer_email: string, customer_name: string, customer_phone: string, customer_type: string, customer_state_registration?: string | null, invoice_address: string }, partner: { __typename?: 'OrderPartnerInfo', trade_name: string, corporate_name: string, document: string, state_registration?: string | null, phone: string, email: string }, timeline: Array<{ __typename?: 'OrderDetailsTimeline', step: string, status: string, subtitle?: string | null, completed: boolean, current: boolean, message?: string | null, title?: string | null, reason?: string | null, error: boolean, warning: boolean, informative: boolean } | null>, products: Array<{ __typename?: 'OrderDetailsProduct', image?: string | null, description: string, sku?: string | null, details: Array<{ __typename?: 'OrderDetailsProductDetail', category: string, descriptions: Array<{ __typename?: 'OrderDetailsProductDescription', name: string, amount: number, datasheet?: string | null } | null> } | null> } | null>, delivery: { __typename?: 'OrderDetailsDelivery', type: string, min_delivery_days?: number | null, max_delivery_days?: number | null, address: { __typename?: 'OrderDetailsAddress', city: string, region: string, street: string, neighborhood: string, zip_code: string, number?: string | null, complement?: string | null, rural_zone?: boolean | null }, recipient?: { __typename?: 'OrderDetailsRecipient', name?: string | null, phone?: string | null, email?: string | null } | null }, deliveries: Array<{ __typename?: 'OrderDelivery', id: string, status: string, invoice_number?: string | null, tracking_link?: string | null, index: number, total: number }>, notes: { __typename?: 'OrderNotes', internal?: string | null, invoice?: string | null }, insurances?: Array<{ __typename?: 'OrderInsurance', coverage_years?: number | null, total?: number | null } | null> | null, summary: { __typename?: 'Summary', body: { __typename?: 'SummaryBody', items: Array<{ __typename?: 'SummaryItem', title: string, type: string, information?: string | null, value: string } | null> } }, actions: Array<{ __typename?: 'OrderAction', id: string, title: string, enabled: boolean, primary?: boolean | null } | null>, triangulation?: { __typename?: 'OrderTriangulation', invoice_issue_date?: string | null, invoice_number?: string | null, invoice_serial_number?: string | null } | null } | null };

export type GetPaymentInfoQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type GetPaymentInfoQuery = { __typename?: 'Query', getPaymentInfo?: { __typename?: 'GetPaymentInfoOut', type?: string | null, value?: string | null, detail?: { __typename?: 'GetPaymentInfoDetailOut', file?: string | null, text?: string | null, expiration_date?: string | null } | null } | null };

export type GetPaymentLinkQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type GetPaymentLinkQuery = { __typename?: 'Query', getPaymentLink?: { __typename?: 'GetPaymentLinkOut', link: string } | null };

export type ListOrdersBackofficeQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  responsible_id?: InputMaybe<Scalars['Int']['input']>;
  has_battery?: InputMaybe<Scalars['Boolean']['input']>;
  has_hybrid_inverter?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListOrdersBackofficeQuery = { __typename?: 'Query', listOrdersBackoffice?: { __typename?: 'ListOrdersBackofficeOut', meta: { __typename?: 'ListOrdersBackofficeOutMeta', page: number, size: number, count: number }, facets: Array<{ __typename?: 'ListOrdersBackofficeOutFacet', filter_name: string, title: string, options: Array<{ __typename?: 'ListOrdersBackofficeOutFacetOption', name: string, value: string } | null> } | null>, data: Array<{ __typename?: 'ListOrdersBackofficeOutData', id: string, number: number, innova_id?: number | null, client_name: string, total_value: string, payment_method: string, request_made_date?: string | null, seller?: string | null, partner_name?: string | null, has_battery?: boolean | null, has_hybrid_inverter?: boolean | null, tracking_link?: string | null, status: { __typename?: 'ListOrdersBackofficeOutStatus', id: string, variant: string, title: string }, actions: Array<{ __typename?: 'OrderAction', id: string, title: string, enabled: boolean } | null>, deliveries: Array<{ __typename?: 'OrderDelivery', id: string }> } | null> } | null };

export type CreateProposalSheetByIdMutationVariables = Exact<{
  proposal_id: Scalars['UUID']['input'];
}>;


export type CreateProposalSheetByIdMutation = { __typename?: 'Mutation', createProposalSheetById?: { __typename?: 'CreateProposalSheetByIdOut', url?: string | null, expires_at?: string | null } | null };

export type GetIntegratorsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIntegratorsQuery = { __typename?: 'Query', getPartners?: { __typename?: 'GetPartnersOut', partners?: Array<{ __typename?: 'Partner', id: number, tradingName?: string | null, cnpj?: string | null, acceptedCurrentOperatingAgreement?: boolean | null, address?: { __typename?: 'Address', zipcode?: string | null, street?: string | null, number?: string | null, complement?: string | null, district?: string | null, city?: string | null, state?: string | null } | null, recipient?: { __typename?: 'Recipient', name?: string | null, email?: string | null, phone?: string | null } | null, responsible?: { __typename?: 'Responsible', recipient?: { __typename?: 'Recipient', name?: string | null, email?: string | null, phone?: string | null } | null } | null } | null> | null } | null };

export type GetProposalsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  has_battery?: InputMaybe<Scalars['Boolean']['input']>;
  has_hybrid_inverter?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProposalsQuery = { __typename?: 'Query', getProposals?: { __typename?: 'GetProposalsOut', meta: { __typename?: 'ProposalMetaOut', page: number, size: number, count: number }, proposals: Array<{ __typename?: 'CartOut', id: string, region?: string | null, channel?: string | null, segmentation_id?: string | null, subtotal: number, total: number, created_at: any, created_at_short?: string | null, created_at_long?: string | null, updated_at?: any | null, finished_at?: any | null, expires_at?: any | null, expiration_days?: string | null, expired_at_short?: string | null, expired_at_long?: string | null, has_battery?: boolean | null, has_hybrid_inverter?: boolean | null, partner: { __typename?: 'PartnerOut', id: number, name?: string | null, user_id: number, user_name?: string | null, responsible_id?: number | null, responsible_name?: string | null, solfacil_plus: { __typename?: 'SolfacilPlusOut', discount_rate: number } }, category: { __typename?: 'CategoryOut', id: number, description: string }, status: { __typename?: 'StatusOut', id: number, description: string }, type: { __typename?: 'TypeOut', id: number, description: string }, proposal?: { __typename?: 'query_getProposals_proposals_items_proposal', code: number, status: { __typename?: 'ProposalStatusOut', id: number, description: string } } | null, products?: Array<{ __typename?: 'CartSpareProductsOut', title?: string | null, items?: Array<{ __typename?: 'GetSpareProductsAssortmentOut', sku?: string | null, region?: string | null, dc_id?: number | null, image?: string | null, manufacturer?: string | null, model?: string | null, description?: string | null, price?: number | null, total_price?: number | null, in_cart?: boolean | null, pre_sale?: boolean | null, available_at?: any | null, quantity?: number | null, datasheet?: string | null, status?: { __typename?: 'CartItemStatusOut', description: string, id: number } | null, info?: Array<{ __typename?: 'GetSpareProductsAssortmentInfoOut', title?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null, items?: Array<{ __typename?: 'CartItemOut', sku: string, amount: number, price_raw: number, price: number, total: number, category?: string | null, datasheet?: string | null, images: Array<{ __typename?: 'ImageOut', url: string } | null>, status: { __typename?: 'CartItemStatusOut', id: number, description: string }, details?: Array<{ __typename?: 'DetailsOut', id: number, category: string, datasheet?: string | null, descriptions: Array<{ __typename?: 'DetailDescriptionOut', name: string, amount: number } | null> } | null> | null } | null> | null } | null> } | null };

export type GetSellersQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellersQuery = { __typename?: 'Query', getUsers?: { __typename?: 'GetUsersOut', users?: Array<{ __typename?: 'User', id: number, fullName?: string | null, email?: string | null, profile?: string | null, partner?: { __typename?: 'Partner', id: number, tradingName?: string | null, cnpj?: string | null, acceptedCurrentOperatingAgreement?: boolean | null, address?: { __typename?: 'Address', zipcode?: string | null, street?: string | null, number?: string | null, complement?: string | null, district?: string | null, city?: string | null, state?: string | null } | null, recipient?: { __typename?: 'Recipient', name?: string | null, email?: string | null, phone?: string | null } | null, responsible?: { __typename?: 'Responsible', recipient?: { __typename?: 'Recipient', name?: string | null, email?: string | null, phone?: string | null } | null } | null } | null } | null> | null } | null };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { __typename?: 'Query', getUser: { __typename?: 'User', email?: string | null, fullName?: string | null, id: number, profile?: string | null, partner?: { __typename?: 'Partner', acceptedCurrentOperatingAgreement?: boolean | null, id: number, tradingName?: string | null, address?: { __typename?: 'Address', city?: string | null, complement?: string | null, district?: string | null, number?: string | null, state?: string | null, street?: string | null, zipcode?: string | null } | null, recipient?: { __typename?: 'Recipient', email?: string | null, name?: string | null, phone?: string | null } | null } | null } };


export const GetAvailabilityAuditByCartIdDocument = gql`
    query getAvailabilityAuditByCartId($cart_id: UUID!) {
  getAvailabilityAuditByCartId(cart_id: $cart_id) {
    overall_status
    cart_id
    distribution_center_id
    region
    items {
      sku
      amount
      status
      product {
        name
        image_url
      }
      stock {
        status
        current
        future
        reserved
      }
      checks {
        exists
        deleted
        has_product_info
        has_cost
        has_price_for_region
      }
      reasons
    }
  }
}
    `;

/**
 * __useGetAvailabilityAuditByCartIdQuery__
 *
 * To run a query within a Vue component, call `useGetAvailabilityAuditByCartIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityAuditByCartIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailabilityAuditByCartIdQuery({
 *   cart_id: // value for 'cart_id'
 * });
 */
export function useGetAvailabilityAuditByCartIdQuery(variables: GetAvailabilityAuditByCartIdQueryVariables | VueCompositionApi.Ref<GetAvailabilityAuditByCartIdQueryVariables> | ReactiveFunction<GetAvailabilityAuditByCartIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>(GetAvailabilityAuditByCartIdDocument, variables, options);
}
export function useGetAvailabilityAuditByCartIdLazyQuery(variables?: GetAvailabilityAuditByCartIdQueryVariables | VueCompositionApi.Ref<GetAvailabilityAuditByCartIdQueryVariables> | ReactiveFunction<GetAvailabilityAuditByCartIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>(GetAvailabilityAuditByCartIdDocument, variables, options);
}
export type GetAvailabilityAuditByCartIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailabilityAuditByCartIdQuery, GetAvailabilityAuditByCartIdQueryVariables>;
export const GetAvailabilityAuditByProposalCodeDocument = gql`
    query getAvailabilityAuditByProposalCode($proposal_code: Int!) {
  getAvailabilityAuditByProposalCode(proposal_code: $proposal_code) {
    overall_status
    cart_id
    distribution_center_id
    region
    items {
      sku
      amount
      status
      product {
        name
        image_url
      }
      stock {
        status
        current
        future
        reserved
      }
      checks {
        exists
        deleted
        has_product_info
        has_cost
        has_price_for_region
      }
      reasons
    }
  }
}
    `;

/**
 * __useGetAvailabilityAuditByProposalCodeQuery__
 *
 * To run a query within a Vue component, call `useGetAvailabilityAuditByProposalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityAuditByProposalCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailabilityAuditByProposalCodeQuery({
 *   proposal_code: // value for 'proposal_code'
 * });
 */
export function useGetAvailabilityAuditByProposalCodeQuery(variables: GetAvailabilityAuditByProposalCodeQueryVariables | VueCompositionApi.Ref<GetAvailabilityAuditByProposalCodeQueryVariables> | ReactiveFunction<GetAvailabilityAuditByProposalCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>(GetAvailabilityAuditByProposalCodeDocument, variables, options);
}
export function useGetAvailabilityAuditByProposalCodeLazyQuery(variables?: GetAvailabilityAuditByProposalCodeQueryVariables | VueCompositionApi.Ref<GetAvailabilityAuditByProposalCodeQueryVariables> | ReactiveFunction<GetAvailabilityAuditByProposalCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>(GetAvailabilityAuditByProposalCodeDocument, variables, options);
}
export type GetAvailabilityAuditByProposalCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailabilityAuditByProposalCodeQuery, GetAvailabilityAuditByProposalCodeQueryVariables>;
export const AdjustCartDocument = gql`
    mutation adjustCart($cart_id: UUID!, $input: AdjustCartInRoute_Input!) {
  adjustCart(cart_id: $cart_id, input: $input) {
    id
    segmentation_id
    channel
    category {
      id
      description
    }
    status {
      id
      description
    }
    proposal {
      code
    }
    partner {
      id
      cnpj
    }
  }
}
    `;

/**
 * __useAdjustCartMutation__
 *
 * To run a mutation, you first call `useAdjustCartMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAdjustCartMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAdjustCartMutation({
 *   variables: {
 *     cart_id: // value for 'cart_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAdjustCartMutation(options: VueApolloComposable.UseMutationOptions<AdjustCartMutation, AdjustCartMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AdjustCartMutation, AdjustCartMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AdjustCartMutation, AdjustCartMutationVariables>(AdjustCartDocument, options);
}
export type AdjustCartMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AdjustCartMutation, AdjustCartMutationVariables>;
export const AddCouponCustomersDocument = gql`
    mutation addCouponCustomers($name: String!, $input: AddCouponCustomersInput!) {
  addCouponCustomers(name: $name, input: $input) {
    id
    name
    status
    customers {
      cnpj
      available_quantity
      used_quantity
    }
  }
}
    `;

/**
 * __useAddCouponCustomersMutation__
 *
 * To run a mutation, you first call `useAddCouponCustomersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCouponCustomersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCouponCustomersMutation({
 *   variables: {
 *     name: // value for 'name'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddCouponCustomersMutation(options: VueApolloComposable.UseMutationOptions<AddCouponCustomersMutation, AddCouponCustomersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCouponCustomersMutation, AddCouponCustomersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCouponCustomersMutation, AddCouponCustomersMutationVariables>(AddCouponCustomersDocument, options);
}
export type AddCouponCustomersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCouponCustomersMutation, AddCouponCustomersMutationVariables>;
export const AddCouponProductsDocument = gql`
    mutation addCouponProducts($name: String!, $input: AddCouponProductsInput!) {
  addCouponProducts(name: $name, input: $input) {
    id
    name
    status
    discount_rate
    discount_amount
    min_purchase_amount
    sales_channel {
      name
    }
    available_quantity
    used_quantity
    customers {
      cnpj
      available_quantity
      used_quantity
    }
    products {
      sku
    }
    created_by
    updated_by
    deleted_by
    expires_in
    created_at
    updated_at
    deleted_at
  }
}
    `;

/**
 * __useAddCouponProductsMutation__
 *
 * To run a mutation, you first call `useAddCouponProductsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCouponProductsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCouponProductsMutation({
 *   variables: {
 *     name: // value for 'name'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddCouponProductsMutation(options: VueApolloComposable.UseMutationOptions<AddCouponProductsMutation, AddCouponProductsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCouponProductsMutation, AddCouponProductsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCouponProductsMutation, AddCouponProductsMutationVariables>(AddCouponProductsDocument, options);
}
export type AddCouponProductsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCouponProductsMutation, AddCouponProductsMutationVariables>;
export const CreateCouponDocument = gql`
    mutation createCoupon($input: CreateCouponInput!) {
  createCoupon(input: $input) {
    id
    name
    status
    created_at
    expires_in
    discount_rate
    description
    discount_amount
    min_purchase_amount
    available_quantity
    used_quantity
    sales_channel {
      name
    }
    customers {
      cnpj
      available_quantity
    }
    products {
      sku
    }
  }
}
    `;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCouponMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponMutation(options: VueApolloComposable.UseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCouponMutation, CreateCouponMutationVariables>(CreateCouponDocument, options);
}
export type CreateCouponMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCouponMutation, CreateCouponMutationVariables>;
export const DeactivateCouponDocument = gql`
    mutation deactivateCoupon($name: String!) {
  deactivateCoupon(name: $name)
}
    `;

/**
 * __useDeactivateCouponMutation__
 *
 * To run a mutation, you first call `useDeactivateCouponMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCouponMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateCouponMutation({
 *   variables: {
 *     name: // value for 'name'
 *   },
 * });
 */
export function useDeactivateCouponMutation(options: VueApolloComposable.UseMutationOptions<DeactivateCouponMutation, DeactivateCouponMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateCouponMutation, DeactivateCouponMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateCouponMutation, DeactivateCouponMutationVariables>(DeactivateCouponDocument, options);
}
export type DeactivateCouponMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateCouponMutation, DeactivateCouponMutationVariables>;
export const GetCouponDetailsDocument = gql`
    query getCouponDetails($id: String!) {
  getCouponDetails(id: $id) {
    id
    name
    status
    created_at
    expires_in
    discount_rate
    discount_amount
    min_purchase_amount
    available_quantity
    used_quantity
    description
    sales_channel {
      name
    }
    customers {
      cnpj
      available_quantity
      used_quantity
    }
    products {
      sku
    }
    created_by
    updated_at
    updated_by
  }
}
    `;

/**
 * __useGetCouponDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCouponDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCouponDetailsQuery(variables: GetCouponDetailsQueryVariables | VueCompositionApi.Ref<GetCouponDetailsQueryVariables> | ReactiveFunction<GetCouponDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>(GetCouponDetailsDocument, variables, options);
}
export function useGetCouponDetailsLazyQuery(variables?: GetCouponDetailsQueryVariables | VueCompositionApi.Ref<GetCouponDetailsQueryVariables> | ReactiveFunction<GetCouponDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>(GetCouponDetailsDocument, variables, options);
}
export type GetCouponDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>;
export const ListCouponsDocument = gql`
    query listCoupons($size: Int!, $page: Int!, $sort: String, $name: String) {
  listCoupons(size: $size, page: $page, sort: $sort, name: $name) {
    data {
      id
      name
      discount_amount
      discount_rate
      status
      created_at
      expires_in
      deleted_at
    }
    meta {
      page
      size
      count
    }
  }
}
    `;

/**
 * __useListCouponsQuery__
 *
 * To run a query within a Vue component, call `useListCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCouponsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCouponsQuery({
 *   size: // value for 'size'
 *   page: // value for 'page'
 *   sort: // value for 'sort'
 *   name: // value for 'name'
 * });
 */
export function useListCouponsQuery(variables: ListCouponsQueryVariables | VueCompositionApi.Ref<ListCouponsQueryVariables> | ReactiveFunction<ListCouponsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListCouponsQuery, ListCouponsQueryVariables>(ListCouponsDocument, variables, options);
}
export function useListCouponsLazyQuery(variables?: ListCouponsQueryVariables | VueCompositionApi.Ref<ListCouponsQueryVariables> | ReactiveFunction<ListCouponsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListCouponsQuery, ListCouponsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListCouponsQuery, ListCouponsQueryVariables>(ListCouponsDocument, variables, options);
}
export type ListCouponsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListCouponsQuery, ListCouponsQueryVariables>;
export const RemoveCouponCustomersDocument = gql`
    mutation removeCouponCustomers($name: String!, $input: RemoveCouponCustomersInput!) {
  removeCouponCustomers(name: $name, input: $input) {
    id
    name
    status
    customers {
      cnpj
      available_quantity
    }
  }
}
    `;

/**
 * __useRemoveCouponCustomersMutation__
 *
 * To run a mutation, you first call `useRemoveCouponCustomersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponCustomersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCouponCustomersMutation({
 *   variables: {
 *     name: // value for 'name'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCouponCustomersMutation(options: VueApolloComposable.UseMutationOptions<RemoveCouponCustomersMutation, RemoveCouponCustomersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveCouponCustomersMutation, RemoveCouponCustomersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveCouponCustomersMutation, RemoveCouponCustomersMutationVariables>(RemoveCouponCustomersDocument, options);
}
export type RemoveCouponCustomersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveCouponCustomersMutation, RemoveCouponCustomersMutationVariables>;
export const RemoveCouponProductsDocument = gql`
    mutation removeCouponProducts($name: String!, $input: RemoveCouponProductsInput!) {
  removeCouponProducts(name: $name, input: $input) {
    id
    name
    status
    products {
      sku
    }
  }
}
    `;

/**
 * __useRemoveCouponProductsMutation__
 *
 * To run a mutation, you first call `useRemoveCouponProductsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponProductsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCouponProductsMutation({
 *   variables: {
 *     name: // value for 'name'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCouponProductsMutation(options: VueApolloComposable.UseMutationOptions<RemoveCouponProductsMutation, RemoveCouponProductsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveCouponProductsMutation, RemoveCouponProductsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveCouponProductsMutation, RemoveCouponProductsMutationVariables>(RemoveCouponProductsDocument, options);
}
export type RemoveCouponProductsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveCouponProductsMutation, RemoveCouponProductsMutationVariables>;
export const UpdateCouponDocument = gql`
    mutation updateCoupon($name: String!, $input: UpdateCouponInput!) {
  updateCoupon(name: $name, input: $input) {
    id
    name
    status
    discount_rate
    discount_amount
    min_purchase_amount
    available_quantity
    used_quantity
    expires_in
    description
    created_at
    updated_at
  }
}
    `;

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCouponMutation({
 *   variables: {
 *     name: // value for 'name'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponMutation(options: VueApolloComposable.UseMutationOptions<UpdateCouponMutation, UpdateCouponMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCouponMutation, UpdateCouponMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCouponMutation, UpdateCouponMutationVariables>(UpdateCouponDocument, options);
}
export type UpdateCouponMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCouponMutation, UpdateCouponMutationVariables>;
export const UpdateCouponCustomerDocument = gql`
    mutation updateCouponCustomer($name: String!, $cnpj: String!, $input: UpdateCouponCustomerInput!) {
  updateCouponCustomer(name: $name, cnpj: $cnpj, input: $input) {
    id
    name
    status
    discount_rate
    discount_amount
    min_purchase_amount
    available_quantity
    used_quantity
    expires_in
    description
    created_at
    updated_at
  }
}
    `;

/**
 * __useUpdateCouponCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCouponCustomerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponCustomerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCouponCustomerMutation({
 *   variables: {
 *     name: // value for 'name'
 *     cnpj: // value for 'cnpj'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponCustomerMutation(options: VueApolloComposable.UseMutationOptions<UpdateCouponCustomerMutation, UpdateCouponCustomerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCouponCustomerMutation, UpdateCouponCustomerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCouponCustomerMutation, UpdateCouponCustomerMutationVariables>(UpdateCouponCustomerDocument, options);
}
export type UpdateCouponCustomerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCouponCustomerMutation, UpdateCouponCustomerMutationVariables>;
export const CancelOrderDocument = gql`
    mutation cancelOrder($order_id: String!, $cancelation_reason: String!) {
  cancelOrder(order_id: $order_id, cancelation_reason: $cancelation_reason) {
    order_id
    status
    __typename
  }
}
    `;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelOrderMutation({
 *   variables: {
 *     order_id: // value for 'order_id'
 *     cancelation_reason: // value for 'cancelation_reason'
 *   },
 * });
 */
export function useCancelOrderMutation(options: VueApolloComposable.UseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
}
export type CancelOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelOrderMutation, CancelOrderMutationVariables>;
export const CreateOrderDeliveryInvoicesDocument = gql`
    mutation createOrderDeliveryInvoices($order_id: String!) {
  createOrderDeliveryInvoices(order_id: $order_id) {
    invoices {
      url
    }
  }
}
    `;

/**
 * __useCreateOrderDeliveryInvoicesMutation__
 *
 * To run a mutation, you first call `useCreateOrderDeliveryInvoicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderDeliveryInvoicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrderDeliveryInvoicesMutation({
 *   variables: {
 *     order_id: // value for 'order_id'
 *   },
 * });
 */
export function useCreateOrderDeliveryInvoicesMutation(options: VueApolloComposable.UseMutationOptions<CreateOrderDeliveryInvoicesMutation, CreateOrderDeliveryInvoicesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrderDeliveryInvoicesMutation, CreateOrderDeliveryInvoicesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrderDeliveryInvoicesMutation, CreateOrderDeliveryInvoicesMutationVariables>(CreateOrderDeliveryInvoicesDocument, options);
}
export type CreateOrderDeliveryInvoicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrderDeliveryInvoicesMutation, CreateOrderDeliveryInvoicesMutationVariables>;
export const CreateOrderInvoiceDocument = gql`
    mutation createOrderInvoice($order_id: String!, $delivery_id: String, $only_base_invoice: Boolean) {
  createOrderInvoice(
    order_id: $order_id
    delivery_id: $delivery_id
    only_base_invoice: $only_base_invoice
  ) {
    invoices {
      url
    }
  }
}
    `;

/**
 * __useCreateOrderInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateOrderInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrderInvoiceMutation({
 *   variables: {
 *     order_id: // value for 'order_id'
 *     delivery_id: // value for 'delivery_id'
 *     only_base_invoice: // value for 'only_base_invoice'
 *   },
 * });
 */
export function useCreateOrderInvoiceMutation(options: VueApolloComposable.UseMutationOptions<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>(CreateOrderInvoiceDocument, options);
}
export type CreateOrderInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>;
export const CreateOrderMirrorByIdDocument = gql`
    mutation createOrderMirrorById($order_id: String!) {
  createOrderMirrorById(order_id: $order_id) {
    url
  }
}
    `;

/**
 * __useCreateOrderMirrorByIdMutation__
 *
 * To run a mutation, you first call `useCreateOrderMirrorByIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMirrorByIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrderMirrorByIdMutation({
 *   variables: {
 *     order_id: // value for 'order_id'
 *   },
 * });
 */
export function useCreateOrderMirrorByIdMutation(options: VueApolloComposable.UseMutationOptions<CreateOrderMirrorByIdMutation, CreateOrderMirrorByIdMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOrderMirrorByIdMutation, CreateOrderMirrorByIdMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOrderMirrorByIdMutation, CreateOrderMirrorByIdMutationVariables>(CreateOrderMirrorByIdDocument, options);
}
export type CreateOrderMirrorByIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOrderMirrorByIdMutation, CreateOrderMirrorByIdMutationVariables>;
export const DownloadOrderDocumentDocument = gql`
    query downloadOrderDocument($order_id: String!, $file_name: String) {
  downloadOrderDocument(order_id: $order_id, file_name: $file_name) {
    url
    expires_at
  }
}
    `;

/**
 * __useDownloadOrderDocumentQuery__
 *
 * To run a query within a Vue component, call `useDownloadOrderDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadOrderDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadOrderDocumentQuery({
 *   order_id: // value for 'order_id'
 *   file_name: // value for 'file_name'
 * });
 */
export function useDownloadOrderDocumentQuery(variables: DownloadOrderDocumentQueryVariables | VueCompositionApi.Ref<DownloadOrderDocumentQueryVariables> | ReactiveFunction<DownloadOrderDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>(DownloadOrderDocumentDocument, variables, options);
}
export function useDownloadOrderDocumentLazyQuery(variables?: DownloadOrderDocumentQueryVariables | VueCompositionApi.Ref<DownloadOrderDocumentQueryVariables> | ReactiveFunction<DownloadOrderDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>(DownloadOrderDocumentDocument, variables, options);
}
export type DownloadOrderDocumentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DownloadOrderDocumentQuery, DownloadOrderDocumentQueryVariables>;
export const GetOrderDetailsBackofficeDocument = gql`
    query getOrderDetailsBackoffice($order_id: String!) {
  getOrderDetailsBackoffice(order_id: $order_id) {
    id
    number
    type
    innova_id
    client_name
    invoice_info {
      customer_document
      customer_email
      customer_name
      customer_phone
      customer_type
      customer_state_registration
      invoice_address
    }
    partner {
      trade_name
      corporate_name
      document
      state_registration
      phone
      email
    }
    timeline {
      step
      status
      subtitle
      completed
      current
      message
      title
      reason
      error
      warning
      informative
    }
    products {
      image
      description
      sku
      details {
        category
        descriptions {
          name
          amount
          datasheet
        }
      }
    }
    delivery {
      type
      min_delivery_days
      max_delivery_days
      address {
        city
        region
        street
        neighborhood
        zip_code
        number
        complement
        rural_zone
      }
      recipient {
        name
        phone
        email
      }
    }
    deliveries {
      id
      status
      invoice_number
      tracking_link
      index
      total
    }
    payment_method
    notes {
      internal
      invoice
    }
    insurances {
      coverage_years
      total
    }
    available_at
    deliveries_title
    pending_payment
    partially_invoiced
    pre_sale
    available_at_date
    delivery_estimate
    schedule_pickup_text
    summary {
      body {
        items {
          title
          type
          information
          value
        }
      }
    }
    documents
    actions {
      id
      title
      enabled
      primary
    }
    tracking_link
    triangulation {
      invoice_issue_date
      invoice_number
      invoice_serial_number
    }
  }
}
    `;

/**
 * __useGetOrderDetailsBackofficeQuery__
 *
 * To run a query within a Vue component, call `useGetOrderDetailsBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDetailsBackofficeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrderDetailsBackofficeQuery({
 *   order_id: // value for 'order_id'
 * });
 */
export function useGetOrderDetailsBackofficeQuery(variables: GetOrderDetailsBackofficeQueryVariables | VueCompositionApi.Ref<GetOrderDetailsBackofficeQueryVariables> | ReactiveFunction<GetOrderDetailsBackofficeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>(GetOrderDetailsBackofficeDocument, variables, options);
}
export function useGetOrderDetailsBackofficeLazyQuery(variables?: GetOrderDetailsBackofficeQueryVariables | VueCompositionApi.Ref<GetOrderDetailsBackofficeQueryVariables> | ReactiveFunction<GetOrderDetailsBackofficeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>(GetOrderDetailsBackofficeDocument, variables, options);
}
export type GetOrderDetailsBackofficeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOrderDetailsBackofficeQuery, GetOrderDetailsBackofficeQueryVariables>;
export const GetPaymentInfoDocument = gql`
    query getPaymentInfo($orderId: String!) {
  getPaymentInfo(order_id: $orderId) {
    type
    value
    detail {
      file
      text
      expiration_date
    }
  }
}
    `;

/**
 * __useGetPaymentInfoQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentInfoQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetPaymentInfoQuery(variables: GetPaymentInfoQueryVariables | VueCompositionApi.Ref<GetPaymentInfoQueryVariables> | ReactiveFunction<GetPaymentInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>(GetPaymentInfoDocument, variables, options);
}
export function useGetPaymentInfoLazyQuery(variables?: GetPaymentInfoQueryVariables | VueCompositionApi.Ref<GetPaymentInfoQueryVariables> | ReactiveFunction<GetPaymentInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>(GetPaymentInfoDocument, variables, options);
}
export type GetPaymentInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentInfoQuery, GetPaymentInfoQueryVariables>;
export const GetPaymentLinkDocument = gql`
    query getPaymentLink($orderId: String!) {
  getPaymentLink(order_id: $orderId) {
    link
  }
}
    `;

/**
 * __useGetPaymentLinkQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentLinkQuery({
 *   orderId: // value for 'orderId'
 * });
 */
export function useGetPaymentLinkQuery(variables: GetPaymentLinkQueryVariables | VueCompositionApi.Ref<GetPaymentLinkQueryVariables> | ReactiveFunction<GetPaymentLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>(GetPaymentLinkDocument, variables, options);
}
export function useGetPaymentLinkLazyQuery(variables?: GetPaymentLinkQueryVariables | VueCompositionApi.Ref<GetPaymentLinkQueryVariables> | ReactiveFunction<GetPaymentLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>(GetPaymentLinkDocument, variables, options);
}
export type GetPaymentLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentLinkQuery, GetPaymentLinkQueryVariables>;
export const ListOrdersBackofficeDocument = gql`
    query listOrdersBackoffice($size: Int!, $page: Int!, $sort: String, $search_term: String, $partner_id: Int, $payment_method: String, $status: String, $responsible_id: Int, $has_battery: Boolean, $has_hybrid_inverter: Boolean) {
  listOrdersBackoffice(
    status: $status
    size: $size
    page: $page
    sort: $sort
    partner_id: $partner_id
    payment_method: $payment_method
    search_term: $search_term
    responsible_id: $responsible_id
    has_battery: $has_battery
    has_hybrid_inverter: $has_hybrid_inverter
  ) {
    meta {
      page
      size
      count
    }
    facets {
      filter_name
      title
      options {
        name
        value
      }
    }
    data {
      id
      number
      innova_id
      client_name
      total_value
      payment_method
      request_made_date
      seller
      partner_name
      has_battery
      has_hybrid_inverter
      status {
        id
        variant
        title
      }
      actions {
        id
        title
        enabled
      }
      deliveries {
        id
      }
      tracking_link
    }
  }
}
    `;

/**
 * __useListOrdersBackofficeQuery__
 *
 * To run a query within a Vue component, call `useListOrdersBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrdersBackofficeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListOrdersBackofficeQuery({
 *   size: // value for 'size'
 *   page: // value for 'page'
 *   sort: // value for 'sort'
 *   search_term: // value for 'search_term'
 *   partner_id: // value for 'partner_id'
 *   payment_method: // value for 'payment_method'
 *   status: // value for 'status'
 *   responsible_id: // value for 'responsible_id'
 *   has_battery: // value for 'has_battery'
 *   has_hybrid_inverter: // value for 'has_hybrid_inverter'
 * });
 */
export function useListOrdersBackofficeQuery(variables: ListOrdersBackofficeQueryVariables | VueCompositionApi.Ref<ListOrdersBackofficeQueryVariables> | ReactiveFunction<ListOrdersBackofficeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>(ListOrdersBackofficeDocument, variables, options);
}
export function useListOrdersBackofficeLazyQuery(variables?: ListOrdersBackofficeQueryVariables | VueCompositionApi.Ref<ListOrdersBackofficeQueryVariables> | ReactiveFunction<ListOrdersBackofficeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>(ListOrdersBackofficeDocument, variables, options);
}
export type ListOrdersBackofficeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ListOrdersBackofficeQuery, ListOrdersBackofficeQueryVariables>;
export const CreateProposalSheetByIdDocument = gql`
    mutation CreateProposalSheetById($proposal_id: UUID!) {
  createProposalSheetById(proposal_id: $proposal_id) {
    url
    expires_at
  }
}
    `;

/**
 * __useCreateProposalSheetByIdMutation__
 *
 * To run a mutation, you first call `useCreateProposalSheetByIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalSheetByIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProposalSheetByIdMutation({
 *   variables: {
 *     proposal_id: // value for 'proposal_id'
 *   },
 * });
 */
export function useCreateProposalSheetByIdMutation(options: VueApolloComposable.UseMutationOptions<CreateProposalSheetByIdMutation, CreateProposalSheetByIdMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateProposalSheetByIdMutation, CreateProposalSheetByIdMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateProposalSheetByIdMutation, CreateProposalSheetByIdMutationVariables>(CreateProposalSheetByIdDocument, options);
}
export type CreateProposalSheetByIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateProposalSheetByIdMutation, CreateProposalSheetByIdMutationVariables>;
export const GetIntegratorsDocument = gql`
    query getIntegrators($name: String) {
  getPartners(page: 1, page_size: 50, term: $name) {
    partners {
      id
      tradingName
      cnpj
      acceptedCurrentOperatingAgreement
      address {
        zipcode
        street
        number
        complement
        district
        city
        state
      }
      recipient {
        name
        email
        phone
      }
      responsible {
        recipient {
          name
          email
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useGetIntegratorsQuery__
 *
 * To run a query within a Vue component, call `useGetIntegratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegratorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIntegratorsQuery({
 *   name: // value for 'name'
 * });
 */
export function useGetIntegratorsQuery(variables: GetIntegratorsQueryVariables | VueCompositionApi.Ref<GetIntegratorsQueryVariables> | ReactiveFunction<GetIntegratorsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIntegratorsQuery, GetIntegratorsQueryVariables>(GetIntegratorsDocument, variables, options);
}
export function useGetIntegratorsLazyQuery(variables: GetIntegratorsQueryVariables | VueCompositionApi.Ref<GetIntegratorsQueryVariables> | ReactiveFunction<GetIntegratorsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIntegratorsQuery, GetIntegratorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIntegratorsQuery, GetIntegratorsQueryVariables>(GetIntegratorsDocument, variables, options);
}
export type GetIntegratorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIntegratorsQuery, GetIntegratorsQueryVariables>;
export const GetProposalsDocument = gql`
    query getProposals($page: Int, $size: Int, $status: String, $sort: String, $code: Int, $partnerId: Int, $sellerId: Int, $has_battery: Boolean, $has_hybrid_inverter: Boolean) {
  getProposals(
    page: $page
    size: $size
    status: $status
    sort: $sort
    code: $code
    partner_id: $partnerId
    responsible_id: $sellerId
    has_battery: $has_battery
    has_hybrid_inverter: $has_hybrid_inverter
  ) {
    meta {
      page
      size
      count
    }
    proposals {
      id
      partner {
        id
        name
        solfacil_plus {
          discount_rate
        }
        user_id
        user_name
        responsible_id
        responsible_name
      }
      category {
        id
        description
      }
      region
      channel
      segmentation_id
      status {
        id
        description
      }
      type {
        id
        description
      }
      proposal {
        code
        status {
          id
          description
        }
      }
      products {
        title
        items {
          sku
          region
          dc_id
          image
          manufacturer
          model
          description
          price
          total_price
          in_cart
          pre_sale
          available_at
          quantity
          status {
            description
            id
          }
          info {
            title
            value
          }
          datasheet
        }
      }
      items {
        sku
        amount
        price_raw
        price
        images {
          url
        }
        status {
          id
          description
        }
        total
        category
        datasheet
        details {
          id
          category
          descriptions {
            name
            amount
          }
          datasheet
        }
      }
      subtotal
      total
      created_at
      created_at_short
      created_at_long
      updated_at
      finished_at
      expires_at
      expiration_days
      expired_at_short
      expired_at_long
      has_battery
      has_hybrid_inverter
    }
  }
}
    `;

/**
 * __useGetProposalsQuery__
 *
 * To run a query within a Vue component, call `useGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProposalsQuery({
 *   page: // value for 'page'
 *   size: // value for 'size'
 *   status: // value for 'status'
 *   sort: // value for 'sort'
 *   code: // value for 'code'
 *   partnerId: // value for 'partnerId'
 *   sellerId: // value for 'sellerId'
 *   has_battery: // value for 'has_battery'
 *   has_hybrid_inverter: // value for 'has_hybrid_inverter'
 * });
 */
export function useGetProposalsQuery(variables: GetProposalsQueryVariables | VueCompositionApi.Ref<GetProposalsQueryVariables> | ReactiveFunction<GetProposalsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, variables, options);
}
export function useGetProposalsLazyQuery(variables: GetProposalsQueryVariables | VueCompositionApi.Ref<GetProposalsQueryVariables> | ReactiveFunction<GetProposalsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetProposalsQuery, GetProposalsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, variables, options);
}
export type GetProposalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetProposalsQuery, GetProposalsQueryVariables>;
export const GetSellersDocument = gql`
    query getSellers($name: String) {
  getUsers(role: "seller", page: 1, page_size: 100, partial_name: $name) {
    users {
      id
      fullName
      email
      profile
      partner {
        id
        tradingName
        cnpj
        acceptedCurrentOperatingAgreement
        address {
          zipcode
          street
          number
          complement
          district
          city
          state
        }
        recipient {
          name
          email
          phone
        }
        responsible {
          recipient {
            name
            email
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSellersQuery__
 *
 * To run a query within a Vue component, call `useGetSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSellersQuery({
 *   name: // value for 'name'
 * });
 */
export function useGetSellersQuery(variables: GetSellersQueryVariables | VueCompositionApi.Ref<GetSellersQueryVariables> | ReactiveFunction<GetSellersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSellersQuery, GetSellersQueryVariables>(GetSellersDocument, variables, options);
}
export function useGetSellersLazyQuery(variables: GetSellersQueryVariables | VueCompositionApi.Ref<GetSellersQueryVariables> | ReactiveFunction<GetSellersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSellersQuery, GetSellersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSellersQuery, GetSellersQueryVariables>(GetSellersDocument, variables, options);
}
export type GetSellersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSellersQuery, GetSellersQueryVariables>;
export const UserInfoDocument = gql`
    query UserInfo {
  getUser {
    email
    fullName
    id
    profile
    partner {
      acceptedCurrentOperatingAgreement
      address {
        city
        complement
        district
        number
        state
        street
        zipcode
      }
      id
      recipient {
        email
        name
        phone
      }
      tradingName
    }
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a Vue component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserInfoQuery();
 */
export function useUserInfoQuery(options: VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, {}, options);
}
export function useUserInfoLazyQuery(options: VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserInfoQuery, UserInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, {}, options);
}
export type UserInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserInfoQuery, UserInfoQueryVariables>;
// Generated code ends here